// Hupla site translations (6 languages)
// Keys are organised by section; keep concise, marketing-tone appropriate per language.

export const LOCALES = [
  { code: "en", label: "English",  native: "English",  flag: "🇬🇧", dir: "ltr" },
  { code: "tr", label: "Turkish",  native: "Türkçe",   flag: "🇹🇷", dir: "ltr" },
  { code: "fr", label: "French",   native: "Français", flag: "🇫🇷", dir: "ltr" },
  { code: "ru", label: "Russian",  native: "Русский",  flag: "🇷🇺", dir: "ltr" },
  { code: "zh", label: "Chinese",  native: "中文",     flag: "🇨🇳", dir: "ltr" },
  { code: "ar", label: "Arabic",   native: "العربية",  flag: "🇸🇦", dir: "rtl" },
];

const T = {
  en: {
    brandContent: {
      mamm: {
        category: "Kids' Fruit Juice",
        tagline: "captures the essence of nature — pure, balanced, honest",
        story: "Mamm turns hydration into a game. Four cheeky animal characters — Kika the monkey, Bogo the elephant, Bambam the dog and Vak the duck — carry 100% mixed fruit juice with vitamins A and C. A healthy juice with a toy on top.",
        highlights: [
          "100% mixed fruit juice (apple, strawberry, plum)",
          "Vitamin C + Vitamin A fortified",
          "No added sugar, no preservatives, no artificial colours",
          "Collectible animal character bottles kids adore",
        ],
        variants: [
          "Kika — Monkey bottle",
          "Bogo — Elephant bottle",
          "Bambam — Dog bottle",
          "Vak — Duck bottle",
        ],
        heroSub: "Four cheeky characters. One healthy juice.",
        attr1: "100% fruit juice",
        attr2: "Vitamin A + C",
        attr3: "No added sugar",
        skuCount: "4 Characters",
        skuFormat: "Character Bottle",
        skuUse: "Collectible",
        family: {
          overline: "Meet the family",
          title: "Four friends. One healthy juice.",
          kika: { name: "Kika", animal: "The Monkey", body: "Cheeky, curious, always in the mood for adventure. Kika brings the strawberry-forward brightness." },
          bogo: { name: "Bogo", animal: "The Elephant", body: "Big-hearted, gentle, and the calm one of the crew. Bogo carries the plum-apple depth." },
          bambam: { name: "Bambam", animal: "The Dog", body: "Loyal, playful, and always ready for another round. Bambam brings a fresh apple-strawberry lift." },
          vak: { name: "Vak", animal: "The Duck", body: "Splashy, sunny and a little cheeky. Vak's the mixed-fruit party in a bottle." },
        },
      },
      buzzer: {
        category: "Energy Drink",
        tagline: "peak performance — laser focus and unleashed productivity",
        story: "Buzzer helps you fire on all cylinders. Guarana releases its caffeine slowly and steadily; B-vitamins keep the mood lifted. No sudden crash — just a longer, cleaner burn. For a functional twist, Buzzer Extra 5G pairs real fruit juice with amino acids, L-Theanine, magnesium and Vitamin C — probably the most nutritionally-thoughtful energy can on the shelf.",
        highlights: [
          "Guarana + high-quality caffeine — clean, sustained lift",
          "Increased alertness, focus, memory & endurance",
          "Türkiye's most-loved energy drink for 25 years",
          "Buzzer Extra 5G: 100% apple & mulberry juice + amino acids, L-Theanine, B-complex and Vitamin C",
        ],
        variants: [
          "Buzzer — 1 L PET Bottle",
          "Buzzer — 500 mL Can",
          "Buzzer — 250 mL Can",
          "Buzzer Extra 5G — 150 mL · Apple & Mulberry",
        ],
      },
      multimalt: {
        category: "Malt Beverage",
        tagline: "health elixir — increases the level of happiness hormones",
        story: "Brewed barley malt marries real apple and mango juice, then finished with traditional botanicals long trusted by nursing mothers. Multimalt Date pairs malt with dates and a full B-vitamin complex. Plant-based nourishment, in a can.",
        highlights: [
          "100% barley malt + real fruit juice",
          "Botanicals: fennel, fenugreek, goat's rue, blessed thistle",
          "B1, B2, B3, B5, B6, Biotin, Folic Acid, B12",
          "No preservatives, no colourants, no added sugar",
        ],
        variants: [
          "Malt · Mango · Apple · Plant Extracts",
          "Date — Malt & date juice · B-vitamin complex",
        ],
        heroSub: "Barley malt + real fruit + botanicals — in a can.",
        attr1: "No added sugar",
        attr2: "No preservatives",
        attr3: "8 B-vitamins",
        skuCount: "2 Elixirs",
        skuFormat: "250 ml Can",
        skuUse: "Fruit + Malt",
        elixirs: {
          overline: "The Two Elixirs",
          title: "Two recipes. One tradition of natural nourishment.",
          mango: {
            name: "The Bright Elixir.",
            flavour: "Mango · Apple · Malt · Botanicals",
            tag: "Everyday nourishment",
            body: "Barley malt with real apple and mango juice, then finished with fennel, fenugreek, goat's rue and blessed thistle — botanicals trusted by nursing mothers for over a century.",
            highlights: [
              "100% barley malt + real fruit juice",
              "Botanicals: fennel, fenugreek, goat's rue, blessed thistle",
              "No preservatives · no colourants · no added sugar",
            ],
          },
          date: {
            name: "The Rich Elixir.",
            flavour: "Date · Malt · Full B-vitamin Complex",
            tag: "Recovery & warmth",
            body: "Barley malt married to date-fruit juice — naturally rich in iron, potassium and magnesium. Fortified with a full B-vitamin complex (B1, B2, B3, B5, B6, Biotin, Folic Acid, B12).",
            highlights: [
              "Malt + date juice — natural iron & potassium",
              "8 essential B-vitamins including Folic Acid",
              "No preservatives · no colourants · no added sugar",
            ],
          },
        },
        lifestyle: {
          caption: "Trusted by nursing mothers for over a century.",
          title: "Nature's nourishment for new mothers.",
          body: "Multimalt draws its strength from two of the most trusted ingredients in maternal wellness — brewed barley malt and rich date fruit — each chosen for how they support the demanding early months of motherhood.",
          benefits: [
            { heading: "Barley Malt", text: "A time-honoured galactagogue. Barley malt is naturally rich in beta-glucan, which is linked to the release of prolactin — the hormone that helps sustain a healthy milk supply. It also delivers slow-burning complex carbohydrates, iron and B-vitamins that help replenish a nursing mother's energy hour after hour." },
            { heading: "Date Fruit", text: "A nutrient-dense superfruit for recovery. Dates are packed with natural iron, potassium, magnesium and fibre — nutrients most needed after childbirth. Their gentle natural sugars offer a clean, sustained lift without added sugar, while their fibre supports digestion during the postpartum weeks." },
          ],
        },
      },
      cafeo: {
        category: "Iced Coffee",
        tagline: "slows down time — intimate, cozy and warm",
        story: "Cafeo is 100% Arabica coffee brewed the way a barista would — then chilled and canned. Three ways to have it: silky Dark Chocolate Truffle, caramel-warm Dulce de Leche, and bracing Dark Americano. No shortcuts.",
        highlights: [
          "100% Arabica — brewed, not powdered",
          "Sugar-free · gluten-free · lactose-free",
          "Three moods, three cans",
          "Ready-to-drink, chilled",
        ],
        variants: ["Dark Chocolate Truffle", "Dulce de Leche", "Dark Americano"],
        heroSub: "Brewed, chilled, canned. Three moods.",
        attr1: "100% Arabica",
        attr2: "Sugar-free",
        attr3: "Ready-to-drink",
        skuCount: "3 Moods",
        skuFormat: "250 ml Can",
        skuUse: "Chilled",
        moods: {
          overline: "The Three Moods",
          title: "Three cans. Three ways to slow down time.",
          darkChoc: {
            name: "The dark and truffled.",
            flavour: "Dark Chocolate Truffle",
            body: "70% cacao meets a slow-brewed Arabica. Best sipped between the meeting and the walk home.",
          },
          dulce: {
            name: "The warm one.",
            flavour: "Dulce de Leche",
            body: "Caramelised milk over cold-brewed espresso. Almost a dessert. Almost.",
          },
          americano: {
            name: "The straight-shot.",
            flavour: "Dark Americano",
            body: "No sugar, no milk. Just brewed Arabica, chilled and canned. The clearest way to start the day.",
          },
        },
        moment: {
          overline: "From bean to can",
          title: "Brewed slow. Never rushed.",
          body: "100% Arabica beans, brewed the way a barista would — then chilled and canned so the ritual holds. Three moods on a stone slab: silky Dark Chocolate Truffle, warm Dulce de Leche, bracing Dark Americano.",
          tag: "Cafeo · Brewed Iced Coffee",
        },
      },
      aperina: {
        category: "Aperitif Mix",
        tagline: "unrivaled taste of originality",
        story: "Aperina is our ready-to-serve cocktail mix — original flavour notes, unmistakable colour, made for the moment a bartender doesn't want to think. Pour over ice, top with soda, orange slice on the rim. Sundown, sorted.",
        highlights: [
          "Ready-to-serve fizzy cocktail base",
          "Signature bittersweet bitter-orange soul",
          "Unmistakable colour and flavour",
          "The barman's easy pour",
        ],
        variants: ["1 L PET Bottle — Original Recipe"],
        heroSub: "A single-recipe apéritif, ready to pour.",
        skuVolume: "1 L",
        skuFormat: "PET Bottle",
        skuRecipe: "Original Recipe",
        momentTitle: "A golden-hour ritual.",
        steps: [
          "Fill a wine glass with ice",
          "Pour Aperina, top with soda and spirit preferred",
          "Finish with an orange slice",
        ],
        momentCaption: "— Aperina, Original Recipe. Served over ice with soda & orange.",
      },
      "white-elephant": {
        category: "Premium Mixer",
        tagline: "defines refinement — a touch of elegance and craftsmanship",
        story: "For serious bars. Real quinine from FeverTree bark, real lemon juice in the bitter lemon, and two premium tonics — Japanese Yuzu for citrus finesse, Barbados Breeze for a warmer, tropical mix.",
        highlights: [
          "Handcrafted tonic with natural quinine",
          "Up to 85 mg quinine from FeverTree bark",
          "Low-calorie · restaurant & bar grade",
          "1 L PET bottle — bar-ready format",
        ],
        variants: [
          "Premium Tonic — Japanese Yuzu",
          "Premium Tonic — Barbados Breeze",
          "Bitter Lemon",
        ],
        heroSub: "Handcrafted mixers, made for serious bars.",
        attr1: "Natural quinine",
        attr2: "Low calorie",
        attr3: "Bar-grade",
        skuVolume: "1 L",
        skuFormat: "PET Bottle",
        skuRange: "3 Recipes",
        triptych: {
          overline: "Three tonics, three moments",
          title: "The bartender's shortlist.",
          yuzu: {
            name: "Japanese Yuzu Tonic",
            pairing: "Best with gin",
            steps: [
              "Fill a highball with cubed ice",
              "Pour 45 ml gin, top with Yuzu tonic",
              "Garnish with a shiso leaf or lemon peel",
            ],
          },
          barbados: {
            name: "Barbados Breeze Tonic",
            pairing: "Best with aged white rum",
            steps: [
              "Fill a copa glass with crushed ice",
              "Pour 45 ml aged white rum, top with Barbados Breeze",
              "Finish with a pink grapefruit peel",
            ],
          },
          bitter: {
            name: "Bitter Lemon",
            pairing: "Best with gin or vodka",
            steps: [
              "Fill a highball with cubed ice",
              "Pour 45 ml gin or vodka, top with Bitter Lemon",
              "Garnish with a lemon twist and mint sprig",
            ],
          },
        },
        moments: {
          overline: "White Elephant moments",
          title: "Where refinement meets the pour.",
          bitter: {
            title: "The bright edge.",
            body: "Bitter Lemon among Mediterranean citrus — real lemon juice, natural quinine, and the crisp edge that lifts a highball or a G&T.",
            tag: "Bitter Lemon",
          },
          tonics: {
            title: "The premium pour.",
            body: "Japanese Yuzu for citrus finesse. Barbados Breeze for tropical warmth. Two tonics, one bar-grade craft — poured over ice with a rosemary sprig.",
            tag: "Japanese Yuzu · Barbados Breeze",
          },
        },
      },
      desser: {
        category: "Sauces & Syrups",
        tagline: "embodies creativity — breaking all the rules of sweetness",
        story: "Desser is the finishing brushstroke — six flavour profiles crafted for baristas, mixologists and pastry chefs. From De Mer Whisper (salted caramel) to Belgravia Celestial (white chocolate, pistachio, banana).",
        highlights: [
          "Chef-grade sauces & syrups",
          "Fruity · nutty · deep · exotic profiles",
          "Full-bodied texture, rich mouthfeel",
          "Innovative bottle + pump system",
        ],
        variants: [
          "De Mer Whisper — Salted Caramel",
          "Madagascar Charm — Vanilla · Framboise",
          "Peruvian Noir — Dark Chocolate Truffle",
          "Ivory Pearl — White Chocolate · Macadamia",
          "Belgravia Celestial — White Choc · Pistachio · Banana",
          "Silken Mist — Dulce de Leche · Almond",
        ],
        heroSub: "Six signatures. Heavenly crafted.",
        attr1: "Chef-grade",
        attr2: "Full-bodied",
        attr3: "Pump system",
        skuCount: "6 Recipes",
        skuFormat: "PET Bottle",
        skuUse: "Coffee · Cocktail · Pastry",
        signatures: {
          overline: "The Six Signatures",
          title: "Six flavours. Six moments to compose.",
          deMer: {
            name: "De Mer Whisper",
            flavour: "Salted Caramel",
            body: "A whisper of ocean salt over slow-cooked butterscotch. Poured over a whisky sour or a rich flat white.",
          },
          madagascar: {
            name: "Madagascar Charm",
            flavour: "Vanilla · Framboise",
            body: "Bourbon vanilla married with raspberry brightness. A house pour for spritzes and French 75s.",
          },
          peruvian: {
            name: "Peruvian Noir",
            flavour: "Dark Chocolate Truffle",
            body: "70% cacao richness with truffle depth. Turns a mocha into a moment, a fondant into a memory.",
          },
          ivory: {
            name: "Ivory Pearl",
            flavour: "White Chocolate · Macadamia",
            body: "Silken white chocolate with toasted macadamia warmth. Ribbons beautifully into cheesecake and gelato.",
          },
          belgravia: {
            name: "Belgravia Celestial",
            flavour: "White Choc · Pistachio · Banana",
            body: "The house's most theatrical composition. Pistachio-and-banana over creamy white chocolate — built for layered desserts.",
          },
          silken: {
            name: "Silken Mist",
            flavour: "Dulce de Leche · Almond",
            body: "Caramelised milk with toasted almond softness. A signature for lattes, tiramisus and slow afternoons.",
          },
        },
      },
    },
    nav: {
      brands: "Brands", about: "About", sustainability: "Sustainability",
      b2b: "B2B", contact: "Contact", cta: "Partner With Us",
      sample: "Request Samples", distributors: "Distributors",
    },
    hero: {
      overline: "A Turkish Producer of Beverage & Food Brands",
      the: "the", tasteOf: "taste of", living: "living", well: "well.",
      subtitle: "From Türkiye to the world since 1998 — a family of brands built for people who care what they drink, eat and share.",
      exploreBrands: "Explore Our Brands", talkTrade: "Talk Trade",
    },
    about: {
      title: "ABOUT US",
      body1: "was born from a simple yet powerful belief: that food and drink are not merely products — they are experiences that connect people.",
      body2: "From the very beginning, our goal has been to craft a global community of taste; one that blends quality, curiosity and emotion into every moment of daily life. Today, under the Hupla umbrella",
      body3: "form a vibrant family of brands — each telling its own story, each evoking a shared feeling of joy.",
    },
    brands: {
      title: "MORE THAN A HOUSE OF BRANDS",
      subtitle: "Each of our brands reflects a different rhythm of life",
      portfolio: "Portfolio", of: "of", dragSwipe: "Drag / Swipe",
      exploreBrand: "Explore", ourBrands: "OUR BRANDS",
      livingCulture: "It's a living culture",
      manifesto1: "Every glass, every sip, every taste tells a story — of hands, of harvests, of home.",
      manifesto2: "From İstanbul to Riyadh, from Lagos to London — Hupla is the joy of living well, shared.",
      cities: "From İstanbul to Riyadh, from Lagos to London.",
    },
    sustainability: {
      title: "SUSTAINABILITY",
      quote: "For us, sustainability is not a goal — it's a way of living.",
      body: "Every step of Hupla's production — from raw ingredient sourcing to packaging — is guided by a commitment to responsibility. Reduced sugar, plant-based recipes, recyclable packaging and honest labels are not add-ons at Hupla — they are the baseline.",
    },
    group: {
      kicker: "Part of the Group",
      title: "Backed by a Swiss investment holding.",
      body: "Hupla is the beverage and food production company in the portfolio of De Almeda Seligmann Capital AG — a Zug-based Swiss investment holding that manages Turkish beverage brands with a long-term, multi-generational vision. Through Swiss governance and Turkish craftsmanship, it sustains ambitious global investments and growth.",
      cta: "dealmedaseligmann.ch",
      pillars: {
        swiss: { title: "Swiss governance", body: "Zug-registered, held to institutional-grade standards of transparency and reporting." },
        long:  { title: "Long-term operator", body: "Patient capital thinking in generations, not quarters — the way beverage brands should be built." },
        global:{ title: "Global reach", body: "Manufacturing rooted in Türkiye, distribution ambition spanning Europe, MENA and beyond." },
      },
    },
    b2b: {
      overline: "B2B Inquiries",
      titleA: "Bring Hupla", titleB: "to your", titleC: "market", titleDot: ".",
      subtitle: "Distributors, importers, chain accounts and horeca operators — tell us where you are and which brands you want on your shelves. Our export team gets back to serious inquiries within 2 business days.",
      bullet1: "Full brand portfolio + specs pack",
      bullet2: "Flexible MOQs & container-mixing",
      bullet3: "Private-label options on select lines",
      bullet4: "Marketing & POS support in-market",
      lblFullName: "Full name *", lblCompany: "Company *", lblEmail: "Business email *",
      lblPhone: "Phone", lblCountry: "Country / market *", lblBrand: "Brand of interest",
      lblInquiryType: "Inquiry type", lblMessage: "Tell us about your business *",
      phFullName: "Jane Doe", phCompany: "Global Beverages Ltd.", phEmail: "jane@company.com",
      phPhone: "+1 555 0100", phCountry: "United Arab Emirates", phBrandAny: "Any / all",
      phMessage: "Volume expectations, current portfolio, target channels…",
      typeDistribution: "Distribution / Import", typeHoreca: "Horeca / On-Trade",
      typePrivate: "Private Label / Co-Manufacturing", typeRetail: "Retail / Modern Trade", typeOther: "Other",
      submit: "Send inquiry", sending: "Sending…",
      privacy: "By submitting, you agree to be contacted by Hupla regarding your inquiry. We don't share your data.",
      successTitle: "Inquiry received.",
      successBody: "Thank you. Our export team will reply within 2 business days.",
      errorFallback: "Something went wrong. Please try again.",
      portfolioOverline: "Take it with you",
      portfolioTitle: "The 2026 Hupla Brand Portfolio.",
      portfolioBody: "13 pages of product specs, positioning notes and hero shots for every brand — Buzzer, Mamm, Multimalt, Cafeo, Aperina, White Elephant and Desser.",
      portfolioBullet1: "Real-world pack sizes, formats and MOQs",
      portfolioBullet2: "Positioning, target consumer & channel fit",
      portfolioBullet3: "Approved product photography, ready for pitch decks",
      portfolioHint: "Get the print-ready PDF ↓",
      portfolioReady: "Your Brand Portfolio 2026 is ready.",
      portfolioDownload: "Download the PDF (2.9 MB)",
    },
    contact: {
      overline: "Contact", titleA: "Say hello,", titleCity: "İstanbul", titleB: "is listening.",
      subtitle: "Our headquarters in Şişli, İstanbul are the nerve centre of Hupla. Reach us for partnerships, media, careers or a simple hello.",
      headquarters: "Headquarters", office: "Office", mobile: "Mobile", email: "Email",
    },
    footer: {
      overline: "Hupla", titleJoy: "The joy", titleRest: "of living well.",
      desc: "A Turkish producer of premium beverages and foods, crafted under our own family of brands for Türkiye and export markets since 1998.",
      navigate: "Navigate", ourBrands: "Our Brands",
      linkHome: "Home", linkAbout: "About", linkBrands: "Brands",
      linkSustainability: "Sustainability", linkB2B: "B2B Inquiry", linkContact: "Contact",
      groupCompany: "A group company of",
      groupTagline: "Zug-based Swiss investment holding — our long-term parent.",
      headOffice: "Head office",
      copyright: "All rights reserved.",
      crafted: "Crafted with care in İstanbul, Türkiye.",
    },
    brandPage: {
      backHome: "Back to Brands", partnerCta: "Partner With Us",
      whatMakes: "What makes it special", closerLook: "A closer look at",
      availableIn: "Available in", productLine: "The product line",
      sideBySide: "Every {name}, side by side.",
      skus: "SKUs", fromDeck: "From the {name} deck",
      pages: "pages", exploreOther: "Explore other brands",
    },
    shows: {
      kicker: "Trade Shows 2026",
      title: "Come meet us on the floor.",
      body: "Book a meeting in advance to lock a private tasting slot with our export team. Sample sets travel with us to every show.",
      book: "Book a meeting",
      showcasing: "Showcasing",
    },
    dist: {
      portalOverline: "Distributor Portal",
      signInTitle: "Sign in.",
      emailPh: "Email",
      passwordPh: "Password",
      signInBtn: "Sign in",
      signingIn: "Signing in…",
      newDist: "New distributor?",
      registerLink: "Register →",
      useAdminLogin: "Please use the admin login.",
      loginFailed: "Login failed",
      registerTitle: "Become a Hupla partner.",
      registerSub: "Tell us who you are and which territory you cover — we'll unlock your portal instantly.",
      phName: "Full name *",
      phCompany: "Company *",
      phEmail: "Business email *",
      phPassword: "Password (min 8 chars) *",
      territoryLabel: "Territory",
      phArea: "Area / region *",
      phCity: "City *",
      phCountry: "Country *",
      createBtn: "Create account",
      creating: "Creating account…",
      alreadyRegistered: "Already registered?",
      signInLink: "Sign in →",
      welcomeToast: "Welcome to Hupla — your distributor account is live.",
      regFailed: "Registration failed",
      welcome: "Welcome, {name}.",
      signOut: "Sign out",
      yourTerritory: "Your Territory",
      colCompany: "Company",
      colArea: "Area",
      colCity: "City",
      colCountry: "Country",
      partnerResources: "Partner resources",
      res1Title: "2026 Brand Portfolio",
      res1Body: "The full 300-dpi presentation deck — all seven brands with product specs and case sizes.",
      res1Action: "Download PDF",
      res2Title: "Request physical samples",
      res2Body: "Order sample cases shipped to your warehouse — we cover freight for onboarded distributors.",
      res2Action: "Request samples",
      res3Title: "Meet us at the shows",
      res3Body: "Gulfood · Anuga · SIAL Paris 2026. Book a private tasting slot with our export team.",
      res3Action: "Book a meeting",
      helpMail: "Need help? Contact export@hupla.world",
    },
    ageGate: {
      overline: "Age Verification",
      title: "You must be 18 or older to enter.",
      body: "This section contains alcoholic beverage content. Please confirm you are of legal drinking age in your country.",
      yes: "I am 18 or older",
      no: "I am under 18",
      rejectedBody: "Sorry — you must be 18 or older to view this content.",
      goHome: "Back to home",
      footer: "Please drink responsibly. Do not share with anyone under legal drinking age.",
    },
    we: {
      moreCocktails: {
        overline: "More from the bar",
        title: "Six more with White Elephant.",
        yuzuSour: {
          pairing: "Yuzu · vodka",
          name: "Yuzu Sour",
          recipe: "45 ml vodka · 15 ml lemon · top with Yuzu Tonic · egg-white foam · yuzu peel.",
        },
        goldenHighball: {
          pairing: "Yuzu · Japanese whisky",
          name: "Golden Highball",
          recipe: "45 ml Japanese whisky · large ice · top with Yuzu Tonic · lemon coin.",
        },
        pinkPaloma: {
          pairing: "Barbados · blanco tequila",
          name: "Pink Paloma",
          recipe: "45 ml tequila blanco · pinch of salt · top with Barbados Breeze · grapefruit wedge.",
        },
        caribbeanSpritz: {
          pairing: "Barbados · aged rum + prosecco",
          name: "Caribbean Spritz",
          recipe: "30 ml aged rum · 60 ml prosecco · top with Barbados Breeze · orange twist.",
        },
        sicilianGT: {
          pairing: "Bitter Lemon · Mediterranean gin",
          name: "Sicilian G&T",
          recipe: "45 ml Mediterranean gin · rosemary sprig · top with Bitter Lemon · lemon wheel.",
        },
        vodkaBitter: {
          pairing: "Bitter Lemon · vodka",
          name: "Cucumber Bitter",
          recipe: "45 ml vodka · 3 cucumber ribbons · top with Bitter Lemon · mint sprig.",
        },
      },
    },
    sample: {
      kicker: "Sample Request",
      title: "Try before you list.",
      sub: "Tell us where to ship and which brands to include — we cover freight to serious accounts.",
      phName: "Full name *",
      phCompany: "Company *",
      phEmail: "Business email *",
      phPhone: "Phone",
      phCountry: "Country / market *",
      phAddress: "Shipping address *",
      brandsLabel: "Brands to include *",
      phNotes: "Notes (optional)",
      submit: "Request Samples",
      sending: "Sending…",
      thanks: "Samples on the way.",
      thanksBody: "Our export team will confirm your shipping address within 2 business days and dispatch the samples straight after.",
      close: "Close",
      errNoBrand: "Please pick at least one brand",
      errServer: "Something went wrong. Please try again.",
      success: "Sample request received — we'll be in touch.",
    },
  },

  tr: {
    brandContent: {
      mamm: {
        category: "Çocuk Meyve Suyu",
        tagline: "doğanın özünü yakalar — saf, dengeli, dürüst",
        story: "Mamm, susuzluk gidermeyi bir oyuna dönüştürür. Dört sevimli hayvan karakter — maymun Kika, fil Bogo, köpek Bambam ve ördek Vak — A ve C vitaminli %100 karışık meyve suyunu taşır. Üzerinde oyuncakla gelen sağlıklı meyve suyu.",
        highlights: [
          "%100 karışık meyve suyu (elma, çilek, erik)",
          "C vitamini + A vitamini ile zenginleştirilmiş",
          "İlave şeker, koruyucu ve yapay renklendirici yok",
          "Çocukların bayıldığı koleksiyonluk hayvan karakter şişeleri",
        ],
        variants: [
          "Kika — Maymun şişe",
          "Bogo — Fil şişe",
          "Bambam — Köpek şişe",
          "Vak — Ördek şişe",
        ],
        heroSub: "Dört sevimli karakter. Bir sağlıklı meyve suyu.",
        attr1: "%100 meyve suyu",
        attr2: "A + C vitamini",
        attr3: "İlave şekersiz",
        skuCount: "4 Karakter",
        skuFormat: "Karakter Şişe",
        skuUse: "Koleksiyonluk",
        family: {
          overline: "Aileyle tanışın",
          title: "Dört dost. Bir sağlıklı meyve suyu.",
          kika: { name: "Kika", animal: "Maymun", body: "Muzip, meraklı, hep macera peşinde. Kika çilek öne çıkan parlaklığı taşır." },
          bogo: { name: "Bogo", animal: "Fil", body: "Büyük yürekli, nazik ve grubun sakin olanı. Bogo, erik-elma derinliğini taşır." },
          bambam: { name: "Bambam", animal: "Köpek", body: "Sadık, oyuncu ve her zaman bir tur daha için hazır. Bambam taze bir elma-çilek dokunuşu getirir." },
          vak: { name: "Vak", animal: "Ördek", body: "Şıpırdayan, güneşli ve biraz muzip. Vak, şişedeki karışık meyve şölenidir." },
        },
      },
      buzzer: {
        category: "Enerji İçeceği",
        tagline: "zirve performans — keskin odak ve serbest kalan verimlilik",
        story: "Buzzer, tüm silindirlerinizin çalışmasına yardımcı olur. Guarana kafeinini yavaş ve istikrarlı bırakır; B vitaminleri ruh halinizi yüksek tutar. Ani düşüş yok — daha uzun ve temiz bir enerji. Fonksiyonel dokunuş için Buzzer Extra 5G, gerçek meyve suyunu amino asitler, L-Teanin, magnezyum ve C vitamini ile birleştirir — muhtemelen raftaki besinsel açıdan en özenli enerji kutusu.",
        highlights: [
          "Guarana + yüksek kaliteli kafein — temiz ve sürekli enerji",
          "Artan uyanıklık, odak, hafıza ve dayanıklılık",
          "25 yıldır Türkiye'nin en sevilen enerji içeceği",
          "Buzzer Extra 5G: %100 elma & dut suyu + amino asitler, L-Teanin, B kompleksi ve C vitamini",
        ],
        variants: [
          "Buzzer — 1 L PET Şişe",
          "Buzzer — 500 mL Kutu",
          "Buzzer — 250 mL Kutu",
          "Buzzer Extra 5G — 150 mL · Elma & Dut",
        ],
      },
      multimalt: {
        category: "Malt İçeceği",
        tagline: "sağlık iksiri — mutluluk hormonlarını artırır",
        story: "Demlenmiş arpa maltı gerçek elma ve mango suyu ile buluşur, ardından emziren annelerin uzun süredir güvendiği geleneksel bitkilerle tamamlanır. Multimalt Date, maltı hurma ve tam B vitamin kompleksi ile eşleştirir. Bir kutuda bitki bazlı besleyicilik.",
        highlights: [
          "%100 arpa maltı + gerçek meyve suyu",
          "Bitkiler: rezene, çemenotu, keçi sedefi, kutsal deve dikeni",
          "B1, B2, B3, B5, B6, Biotin, Folik Asit, B12",
          "Koruyucu, renklendirici ve ilave şeker yok",
        ],
        variants: [
          "Malt · Mango · Elma · Bitki Özleri",
          "Hurma — Malt & hurma suyu · B vitamin kompleksi",
        ],
        heroSub: "Arpa maltı + gerçek meyve + bitkiler — kutuda.",
        attr1: "İlave şekersiz",
        attr2: "Koruyucusuz",
        attr3: "8 B-vitamini",
        skuCount: "2 İksir",
        skuFormat: "250 ml Kutu",
        skuUse: "Meyve + Malt",
        elixirs: {
          overline: "İki İksir",
          title: "İki tarif. Doğal besleyiciliğin bir geleneği.",
          mango: {
            name: "Parlak İksir.",
            flavour: "Mango · Elma · Malt · Bitkiler",
            tag: "Günlük besleyicilik",
            body: "Arpa maltı, gerçek elma ve mango suyu ile buluşur ve emziren annelerin bir asırdır güvendiği rezene, çemenotu, keçi sedefi ve kutsal deve dikeniyle tamamlanır.",
            highlights: [
              "%100 arpa maltı + gerçek meyve suyu",
              "Bitkiler: rezene, çemenotu, keçi sedefi, kutsal deve dikeni",
              "Koruyucusuz · renklendiricisiz · ilave şekersiz",
            ],
          },
          date: {
            name: "Zengin İksir.",
            flavour: "Hurma · Malt · Tam B-vitamin Kompleksi",
            tag: "İyileşme & sıcaklık",
            body: "Arpa maltı, hurma suyuyla birleşir — doğal demir, potasyum ve magnezyum açısından zengindir. Tam bir B-vitamin kompleksiyle güçlendirilmiştir (B1, B2, B3, B5, B6, Biotin, Folik Asit, B12).",
            highlights: [
              "Malt + hurma suyu — doğal demir & potasyum",
              "Folik Asit dahil 8 temel B-vitamini",
              "Koruyucusuz · renklendiricisiz · ilave şekersiz",
            ],
          },
        },
        lifestyle: {
          caption: "Bir asırdır emziren annelerin güvendiği besin.",
          title: "Yeni anneler için doğanın besleyici gücü.",
          body: "Multimalt gücünü, annelik yolculuğunun ilk aylarını desteklemek için özenle seçilmiş iki değerli bileşenden alır — demlenmiş arpa maltı ve zengin hurma meyvesi.",
          benefits: [
            { heading: "Arpa Maltı", text: "Yüzyıllardır güvenilen bir galaktagog. Arpa maltı doğal olarak beta-glukan bakımından zengindir; bu bileşen, sağlıklı süt üretimini destekleyen prolaktin hormonuyla ilişkilendirilir. Ayrıca yavaş salınan karmaşık karbonhidratlar, demir ve B vitaminleri sağlayarak emziren annenin enerjisini saat saat yeniler." },
            { heading: "Hurma Meyvesi", text: "İyileşme dönemi için besin değeri yüksek bir süper meyve. Hurma doğal demir, potasyum, magnezyum ve lif açısından zengindir — doğum sonrası en çok ihtiyaç duyulan besinler. Doğal şekerleri ilave şeker olmadan temiz ve sürekli bir enerji sunarken, lifi de doğum sonrası dönemde sindirimi destekler." },
          ],
        },
      },
      cafeo: {
        category: "Soğuk Kahve",
        tagline: "zamanı yavaşlatır — samimi, sıcak ve rahat",
        story: "Cafeo, bir baristanın demlediği gibi hazırlanan %100 Arabica kahvedir — sonra soğutulup kutuya alınır. Üç şekilde tadılır: ipeksi Bitter Çikolata Truffle, karamel sıcaklığında Dulce de Leche ve canlandırıcı Dark Americano. Kısa yol yok.",
        highlights: [
          "%100 Arabica — demlenmiş, toz değil",
          "Şekersiz · glütensiz · laktozsuz",
          "Üç ruh hali, üç kutu",
          "İçime hazır, soğuk",
        ],
        variants: ["Bitter Çikolata Truffle", "Dulce de Leche", "Dark Americano"],
        heroSub: "Demlenmiş, soğutulmuş, kutulanmış. Üç ruh hali.",
        attr1: "%100 Arabica",
        attr2: "Şekersiz",
        attr3: "İçime hazır",
        skuCount: "3 Ruh Hali",
        skuFormat: "250 ml Kutu",
        skuUse: "Soğuk",
        moods: {
          overline: "Üç Ruh Hali",
          title: "Üç kutu. Zamanı yavaşlatmanın üç yolu.",
          darkChoc: {
            name: "Koyu ve trüflü olan.",
            flavour: "Bitter Çikolata Truffle",
            body: "%70 kakao, yavaş demlenmiş Arabica ile buluşur. Toplantı ile eve yürüyüş arasında yudumlanır.",
          },
          dulce: {
            name: "Sıcak olan.",
            flavour: "Dulce de Leche",
            body: "Karamelize süt, soğuk demleme espresso üzerinde. Neredeyse tatlı. Neredeyse.",
          },
          americano: {
            name: "Dümdüz vuran.",
            flavour: "Dark Americano",
            body: "Şeker yok, süt yok. Sadece demlenmiş Arabica, soğutulmuş ve kutulanmış. Güne başlamanın en berrak yolu.",
          },
        },
        moment: {
          overline: "Çekirdekten kutuya",
          title: "Yavaş demlendi. Aceleye getirilmedi.",
          body: "%100 Arabica çekirdekleri, bir baristanın demlediği gibi — sonra soğutulup kutulandı ki tören bozulmasın. Taş bir kaide üstünde üç ruh hali: ipeksi Bitter Çikolata Truffle, sıcak Dulce de Leche, canlandırıcı Dark Americano.",
          tag: "Cafeo · Demlenmiş Soğuk Kahve",
        },
      },
      aperina: {
        category: "Aperitif Karışımı",
        tagline: "rakipsiz özgünlük tadı",
        story: "Aperina, içime hazır kokteyl karışımımızdır — orijinal aroma notaları, tanınabilir rengi ve bir barmenin düşünmek istemediği anlar için hazırlanmıştır. Buza dökün, sodayla tamamlayın, kenarına portakal dilimi koyun. Gün batımı hazır.",
        highlights: [
          "İçime hazır köpüklü kokteyl bazı",
          "Karakteristik tatlı-acı portakal ruhu",
          "Yanılmaz renk ve tat",
          "Barmenin kolay dökümü",
        ],
        variants: ["1 L PET Şişe — Orijinal Tarif"],
        heroSub: "Tek reçeteli aperitif, servise hazır.",
        skuVolume: "1 L",
        skuFormat: "PET Şişe",
        skuRecipe: "Orijinal Tarif",
        momentTitle: "Altın saat ritüeli.",
        steps: [
          "Kadehi buzla doldurun",
          "Aperina'yı dökün, soda ve tercih ettiğiniz alkol ile tamamlayın",
          "Bir dilim portakalla süsleyin",
        ],
        momentCaption: "— Aperina, Orijinal Tarif. Buz, soda ve portakalla servis edilir.",
      },
      "white-elephant": {
        category: "Premium Mikser",
        tagline: "inceliği tanımlar — bir dokunuş zarafet ve ustalık",
        story: "Ciddi barlar için. FeverTree kabuğundan gerçek kinin, bitter limonda gerçek limon suyu ve iki premium tonik — narenciye zarafeti için Japanese Yuzu, daha sıcak ve tropikal karışım için Barbados Breeze.",
        highlights: [
          "Doğal kininli el yapımı tonik",
          "FeverTree kabuğundan 85 mg'a kadar kinin",
          "Düşük kalori · restoran & bar kalitesinde",
          "1 L PET şişe — bara hazır format",
        ],
        variants: [
          "Premium Tonik — Japanese Yuzu",
          "Premium Tonik — Barbados Breeze",
          "Bitter Limon",
        ],
        heroSub: "El yapımı mikserler, ciddi barlar için.",
        attr1: "Doğal kinin",
        attr2: "Düşük kalori",
        attr3: "Bar kalitesinde",
        skuVolume: "1 L",
        skuFormat: "PET Şişe",
        skuRange: "3 Tarif",
        triptych: {
          overline: "Üç tonik, üç an",
          title: "Barmenin kısa listesi.",
          yuzu: {
            name: "Japanese Yuzu Tonik",
            pairing: "En iyi cin ile",
            steps: [
              "Highball bardağı küp buzla doldurun",
              "45 ml cin dökün, Yuzu tonikle tamamlayın",
              "Shiso yaprağı veya limon kabuğuyla süsleyin",
            ],
          },
          barbados: {
            name: "Barbados Breeze Tonik",
            pairing: "En iyi eskitilmiş beyaz romla",
            steps: [
              "Copa kadehi kırılmış buzla doldurun",
              "45 ml eskitilmiş beyaz rom dökün, Barbados Breeze ile tamamlayın",
              "Pembe greyfurt kabuğuyla bitirin",
            ],
          },
          bitter: {
            name: "Bitter Limon",
            pairing: "En iyi cin veya votkayla",
            steps: [
              "Highball bardağı küp buzla doldurun",
              "45 ml cin veya votka dökün, Bitter Limon ile tamamlayın",
              "Limon kabuğu ve nane dalıyla süsleyin",
            ],
          },
        },
        moments: {
          overline: "White Elephant anları",
          title: "İnceliğin dökülüşle buluştuğu yer.",
          bitter: {
            title: "Parlak kenar.",
            body: "Akdeniz narenciyeleri arasında Bitter Limon — gerçek limon suyu, doğal kinin ve bir highball ya da G&T'yi yükselten net kenar.",
            tag: "Bitter Limon",
          },
          tonics: {
            title: "Premium dökülüş.",
            body: "Narenciye zarafeti için Japanese Yuzu. Tropikal sıcaklık için Barbados Breeze. İki tonik, tek bar-kalite ustalık — buzun üzerine biberiye dalıyla dökülür.",
            tag: "Japanese Yuzu · Barbados Breeze",
          },
        },
      },
      desser: {
        category: "Soslar & Şuruplar",
        tagline: "yaratıcılığı simgeler — tatlılığın tüm kurallarını yıkar",
        story: "Desser son fırça darbesidir — baristalar, miksologlar ve pasta şefleri için tasarlanmış altı aroma profili. De Mer Whisper (tuzlu karamel) ile Belgravia Celestial (beyaz çikolata, antep fıstığı, muz) arasında.",
        highlights: [
          "Şef kalitesinde soslar & şuruplar",
          "Meyveli · kuruyemişli · derin · egzotik profiller",
          "Dolu dolu doku, zengin ağız hissi",
          "Yenilikçi şişe + pompa sistemi",
        ],
        variants: [
          "De Mer Whisper — Tuzlu Karamel",
          "Madagascar Charm — Vanilya · Framboise",
          "Peruvian Noir — Bitter Çikolata Truffle",
          "Ivory Pearl — Beyaz Çikolata · Makademya",
          "Belgravia Celestial — Beyaz Çikolata · Antep Fıstığı · Muz",
          "Silken Mist — Dulce de Leche · Badem",
        ],
        heroSub: "Altı imza. Cennet gibi işlenmiş.",
        attr1: "Şef kalitesinde",
        attr2: "Dolu gövdeli",
        attr3: "Pompa sistemi",
        skuCount: "6 Tarif",
        skuFormat: "PET Şişe",
        skuUse: "Kahve · Kokteyl · Pasta",
        signatures: {
          overline: "Altı İmza",
          title: "Altı aroma. Bestelenecek altı an.",
          deMer: {
            name: "De Mer Whisper",
            flavour: "Tuzlu Karamel",
            body: "Yavaş pişirilmiş karamele fısıldayan bir okyanus tuzu. Whisky sour ya da yoğun bir flat white üzerine dökülür.",
          },
          madagascar: {
            name: "Madagascar Charm",
            flavour: "Vanilya · Framboise",
            body: "Bourbon vanilyası, ahududu parlaklığıyla buluşur. Spritz ve French 75 için ev servisidir.",
          },
          peruvian: {
            name: "Peruvian Noir",
            flavour: "Bitter Çikolata Truffle",
            body: "%70 kakao zenginliği, truffle derinliğiyle. Bir mokaya an, bir fondana anı kazandırır.",
          },
          ivory: {
            name: "Ivory Pearl",
            flavour: "Beyaz Çikolata · Makademya",
            body: "İpeksi beyaz çikolata, kavrulmuş makademya sıcaklığıyla. Cheesecake ve gelatoya zarifçe kurdele olur.",
          },
          belgravia: {
            name: "Belgravia Celestial",
            flavour: "Beyaz Çikolata · Antep Fıstığı · Muz",
            body: "Evin en teatral kompozisyonu. Kremalı beyaz çikolata üzerinde antep fıstığı ve muz — katmanlı tatlılar için tasarlanmıştır.",
          },
          silken: {
            name: "Silken Mist",
            flavour: "Dulce de Leche · Badem",
            body: "Karamelize süt, kavrulmuş badem yumuşaklığıyla. Latte, tiramisu ve uzun öğleden sonralar için bir imza.",
          },
        },
      },
    },
    nav: {
      brands: "Markalar", about: "Hakkımızda", sustainability: "Sürdürülebilirlik",
      b2b: "B2B", contact: "İletişim", cta: "İş Ortağı Olun",
      sample: "Numune İsteyin", distributors: "Distribütörler",
    },
    hero: {
      overline: "Türk İçecek & Gıda Markaları Üreticisi",
      the: "iyi", tasteOf: "yaşamın", living: "gerçek", well: "tadı.",
      subtitle: "1998'den beri Türkiye'den dünyaya — içtiğine, yediğine ve paylaştığına önem verenler için kurulmuş bir marka ailesi.",
      exploreBrands: "Markalarımızı Keşfet", talkTrade: "Ticaret Görüşmesi",
    },
    about: {
      title: "HAKKIMIZDA",
      body1: "basit ama güçlü bir inanıştan doğdu: yiyecek ve içecek yalnızca ürün değil — insanları birbirine bağlayan deneyimlerdir.",
      body2: "Baştan beri amacımız; kalite, merak ve duyguyu her günlük ana katan küresel bir lezzet topluluğu yaratmaktı. Bugün Hupla çatısı altında",
      body3: "canlı bir marka ailesi oluşturuyor — her biri kendi hikâyesini anlatıyor, her biri paylaşılan bir neşe uyandırıyor.",
    },
    brands: {
      title: "MARKA AİLESİNDEN DAHA FAZLASI",
      subtitle: "Markalarımızın her biri farklı bir yaşam ritmini yansıtır",
      portfolio: "Portföy", of: "/", dragSwipe: "Sürükle / Kaydır",
      exploreBrand: "Keşfet", ourBrands: "MARKALARIMIZ",
      livingCulture: "Yaşayan bir kültür",
      manifesto1: "Her bardak, her yudum, her tat bir hikâye anlatır — ellerin, hasadın, evin hikâyesini.",
      manifesto2: "İstanbul'dan Riyad'a, Lagos'tan Londra'ya — Hupla, paylaşılan iyi yaşamın keyfidir.",
      cities: "İstanbul'dan Riyad'a, Lagos'tan Londra'ya.",
    },
    sustainability: {
      title: "SÜRDÜRÜLEBİLİRLİK",
      quote: "Bizim için sürdürülebilirlik bir hedef değil — bir yaşam biçimidir.",
      body: "Hupla'nın üretiminin her adımı — ham madde tedarikinden ambalajlamaya — sorumluluk taahhüdüyle şekillendirilir. Azaltılmış şeker, bitki bazlı tarifler, geri dönüştürülebilir ambalajlar ve dürüst etiketler bizde bir ek değil — temeldir.",
    },
    group: {
      kicker: "Grubun Bir Parçası",
      title: "Bir İsviçre yatırım holdinginin desteğiyle.",
      body: "Hupla, De Almeda Seligmann Capital AG'nin portföyünde olan içecek ve gıda üretim şirketidir — Zug merkezli bir İsviçre yatırım holdingi olan bu grup, Türk içecek markalarını uzun vadeli, nesillere yayılan bir vizyonla yönetir. İsviçre yönetimi ve Türk zanaatkarlığı ile küresel boyuttaki iddialı yatırımlarını ve büyümesini sürdürür.",
      cta: "dealmedaseligmann.ch",
      pillars: {
        swiss: { title: "İsviçre yönetimi", body: "Zug'da kayıtlı, kurumsal düzeyde şeffaflık ve raporlama standartlarına bağlı." },
        long:  { title: "Uzun vadeli yatırım", body: "Çeyrekleri değil kuşakları düşünen sabırlı sermaye — içecek markaları böyle inşa edilir." },
        global:{ title: "Küresel erişim", body: "Üretim Türkiye'de köklü, dağıtım hedefi Avrupa, MENA ve ötesini kapsıyor." },
      },
    },
    b2b: {
      overline: "B2B Talepleri",
      titleA: "Hupla", titleB: "sizin", titleC: "pazarınızda", titleDot: ".",
      subtitle: "Distribütörler, ithalatçılar, zincir mağazalar ve horeca operatörleri — bize nerede olduğunuzu ve raflarınızda hangi markaları görmek istediğinizi yazınız. İhracat ekibimiz ciddi taleplere 2 iş günü içinde döner.",
      bullet1: "Tam marka portföyü + spesifikasyon paketi",
      bullet2: "Esnek MOQ'lar & konteyner karışımı",
      bullet3: "Seçili ürünlerde özel etiket seçenekleri",
      bullet4: "Pazarda pazarlama & POS desteği",
      lblFullName: "Ad Soyad *", lblCompany: "Şirket *", lblEmail: "İş e-postası *",
      lblPhone: "Telefon", lblCountry: "Ülke / pazar *", lblBrand: "İlgilenilen marka",
      lblInquiryType: "Talep tipi", lblMessage: "Bize işinizden bahsedin *",
      phFullName: "Ali Yılmaz", phCompany: "Küresel Gıda A.Ş.", phEmail: "ali@sirket.com",
      phPhone: "+90 555 0100", phCountry: "Türkiye", phBrandAny: "Herhangi / hepsi",
      phMessage: "Hacim beklentileri, mevcut portföy, hedef kanallar…",
      typeDistribution: "Dağıtım / İthalat", typeHoreca: "Horeca / On-Trade",
      typePrivate: "Özel Etiket / Fason Üretim", typeRetail: "Perakende", typeOther: "Diğer",
      submit: "Talebi Gönder", sending: "Gönderiliyor…",
      privacy: "Gönderdiğinizde talebiniz için Hupla tarafından iletişime geçilmesini kabul etmiş olursunuz. Verilerinizi paylaşmayız.",
      successTitle: "Talep alındı.",
      successBody: "Teşekkürler. İhracat ekibimiz 2 iş günü içinde yanıtlayacak.",
      errorFallback: "Bir hata oluştu. Lütfen tekrar deneyin.",
      portfolioOverline: "Yanınızda taşıyın",
      portfolioTitle: "2026 Hupla Marka Portföyü.",
      portfolioBody: "Her marka için ürün spesifikasyonları, konumlandırma notları ve ana görselleri içeren 13 sayfa — Buzzer, Mamm, Multimalt, Cafeo, Aperina, White Elephant ve Desser.",
      portfolioBullet1: "Gerçek ambalaj boyutları, formatlar ve MOQ'lar",
      portfolioBullet2: "Konumlandırma, hedef tüketici ve kanal uyumu",
      portfolioBullet3: "Sunum destelerine hazır onaylı ürün fotoğrafları",
      portfolioHint: "Basıma hazır PDF'i alın ↓",
      portfolioReady: "2026 Marka Portföyünüz hazır.",
      portfolioDownload: "PDF'i indir (2.9 MB)",
    },
    contact: {
      overline: "İletişim", titleA: "Merhaba,", titleCity: "İstanbul", titleB: "dinlemede.",
      subtitle: "İstanbul'daki genel merkezimiz Hupla'nın ana yönetimidir. İş ortaklıkları, medya, kariyer veya sadece bir merhaba için bize ulaşabilirsiniz.",
      headquarters: "Genel Merkez", office: "Ofis", mobile: "Mobil", email: "E-posta",
    },
    footer: {
      overline: "Hupla", titleJoy: "İyi yaşamanın", titleRest: "keyfi.",
      desc: "1998'den beri Türkiye ve ihracat pazarları için kendi marka ailemizle üretilen premium içecekler ve gıdaların Türk üreticisi.",
      navigate: "Menü", ourBrands: "Markalarımız",
      linkHome: "Anasayfa", linkAbout: "Hakkımızda", linkBrands: "Markalar",
      linkSustainability: "Sürdürülebilirlik", linkB2B: "B2B Talebi", linkContact: "İletişim",
      groupCompany: "Grup şirketi",
      groupTagline: "Zug merkezli İsviçre yatırım holdingi — uzun vadeli ana ortağımız.",
      headOffice: "Genel Merkez",
      copyright: "Tüm hakları saklıdır.",
      crafted: "İstanbul, Türkiye'de özenle üretilmiştir.",
    },
    brandPage: {
      backHome: "Markalara Dön", partnerCta: "İş Ortağı Olun",
      whatMakes: "Onu özel kılan", closerLook: "Daha yakından",
      availableIn: "Şu varyantlarda", productLine: "Ürün Ailesi",
      sideBySide: "Tüm {name}, yan yana.",
      skus: "Ürün", fromDeck: "{name} sunumundan",
      pages: "sayfa", exploreOther: "Diğer markaları keşfedin",
    },
    shows: {
      kicker: "2026 Fuar Takvimi",
      title: "Standımızda buluşalım.",
      body: "İhracat ekibimizle özel bir tadım randevusu almak için önceden görüşme ayarlayın. Numune setlerimiz her fuara bizimle geliyor.",
      book: "Görüşme ayarla",
      showcasing: "Sergilenen markalar",
    },
    dist: {
      portalOverline: "Distribütör Portalı",
      signInTitle: "Giriş yapın.",
      emailPh: "E-posta",
      passwordPh: "Şifre",
      signInBtn: "Giriş yap",
      signingIn: "Giriş yapılıyor…",
      newDist: "Yeni distribütör müsünüz?",
      registerLink: "Kayıt ol →",
      useAdminLogin: "Lütfen yönetici girişini kullanın.",
      loginFailed: "Giriş başarısız",
      registerTitle: "Hupla iş ortağı olun.",
      registerSub: "Kim olduğunuzu ve hangi bölgeyi kapsadığınızı söyleyin — portalınızı anında açalım.",
      phName: "Ad Soyad *",
      phCompany: "Şirket *",
      phEmail: "İş e-postası *",
      phPassword: "Şifre (min. 8 karakter) *",
      territoryLabel: "Bölge",
      phArea: "Bölge / alan *",
      phCity: "Şehir *",
      phCountry: "Ülke *",
      createBtn: "Hesap oluştur",
      creating: "Hesap oluşturuluyor…",
      alreadyRegistered: "Zaten kayıtlı mısınız?",
      signInLink: "Giriş yap →",
      welcomeToast: "Hupla'ya hoş geldiniz — distribütör hesabınız aktif.",
      regFailed: "Kayıt başarısız",
      welcome: "Hoş geldiniz, {name}.",
      signOut: "Çıkış yap",
      yourTerritory: "Bölgeniz",
      colCompany: "Şirket",
      colArea: "Bölge",
      colCity: "Şehir",
      colCountry: "Ülke",
      partnerResources: "İş ortağı kaynakları",
      res1Title: "2026 Marka Portföyü",
      res1Body: "Tam 300-dpi sunum destesi — yedi markanın tamamı, ürün spesifikasyonları ve koli boyutlarıyla.",
      res1Action: "PDF'i indir",
      res2Title: "Fiziksel numune isteyin",
      res2Body: "Deponuza gönderilecek numune kolileri sipariş edin — anlaşmalı distribütörler için nakliyeyi biz karşılıyoruz.",
      res2Action: "Numune iste",
      res3Title: "Fuarlarda buluşalım",
      res3Body: "Gulfood · Anuga · SIAL Paris 2026. İhracat ekibimizle özel bir tadım randevusu ayarlayın.",
      res3Action: "Görüşme ayarla",
      helpMail: "Yardım gerekli mi? export@hupla.world",
    },
    ageGate: {
      overline: "Yaş Doğrulama",
      title: "Girmek için 18 yaşından büyük olmalısınız.",
      body: "Bu bölüm alkollü içki içeriği içerir. Lütfen ülkenizde yasal içki yaşında olduğunuzu onaylayın.",
      yes: "18 yaşından büyüğüm",
      no: "18 yaşından küçüğüm",
      rejectedBody: "Üzgünüz — bu içeriği görüntülemek için 18 yaşından büyük olmalısınız.",
      goHome: "Ana sayfaya dön",
      footer: "Sorumlu tüketim tavsiye edilir. Yasal içki yaşının altındakilerle paylaşmayın.",
    },
    we: {
      moreCocktails: {
        overline: "Barın devamı",
        title: "White Elephant ile altı klasik daha.",
        yuzuSour: {
          pairing: "Yuzu · votka",
          name: "Yuzu Sour",
          recipe: "45 ml votka · 15 ml limon · Yuzu Tonic ile tamamlayın · yumurta akı köpüğü · yuzu kabuğu.",
        },
        goldenHighball: {
          pairing: "Yuzu · Japon viskisi",
          name: "Golden Highball",
          recipe: "45 ml Japon viskisi · büyük buz küpü · Yuzu Tonic ile tamamlayın · limon dilimi.",
        },
        pinkPaloma: {
          pairing: "Barbados · blanco tekila",
          name: "Pink Paloma",
          recipe: "45 ml blanco tekila · bir tutam tuz · Barbados Breeze ile tamamlayın · greyfurt dilimi.",
        },
        caribbeanSpritz: {
          pairing: "Barbados · yıllanmış rom + prosecco",
          name: "Caribbean Spritz",
          recipe: "30 ml yıllanmış rom · 60 ml prosecco · Barbados Breeze ile tamamlayın · portakal kabuğu.",
        },
        sicilianGT: {
          pairing: "Bitter Lemon · Akdeniz cin",
          name: "Sicilian G&T",
          recipe: "45 ml Akdeniz cin · biberiye dalı · Bitter Lemon ile tamamlayın · limon dilimi.",
        },
        vodkaBitter: {
          pairing: "Bitter Lemon · votka",
          name: "Cucumber Bitter",
          recipe: "45 ml votka · 3 salatalık dilimi · Bitter Lemon ile tamamlayın · nane dalı.",
        },
      },
    },
    sample: {
      kicker: "Numune Talebi",
      title: "Listelemeden önce deneyin.",
      sub: "Nereye göndereceğimizi ve hangi markaları dahil edeceğimizi bize söyleyin — ciddi hesaplar için nakliyeyi biz karşılıyoruz.",
      phName: "Ad Soyad *",
      phCompany: "Şirket *",
      phEmail: "İş e-postası *",
      phPhone: "Telefon",
      phCountry: "Ülke / pazar *",
      phAddress: "Kargo adresi *",
      brandsLabel: "Dahil edilecek markalar *",
      phNotes: "Notlar (isteğe bağlı)",
      submit: "Numune İste",
      sending: "Gönderiliyor…",
      thanks: "Numuneler yola çıkıyor.",
      thanksBody: "İhracat ekibimiz kargo adresinizi 2 iş günü içinde teyit edecek ve numuneleri hemen ardından gönderecek.",
      close: "Kapat",
      errNoBrand: "Lütfen en az bir marka seçin",
      errServer: "Bir şeyler ters gitti. Lütfen tekrar deneyin.",
      success: "Numune talebi alındı — sizinle iletişime geçeceğiz.",
    },
  },

  fr: {
    brandContent: {
      mamm: {
        category: "Jus de fruits pour enfants",
        tagline: "capture l'essence de la nature — pure, équilibrée, honnête",
        story: "Mamm transforme l'hydratation en jeu. Quatre personnages animaux malicieux — Kika le singe, Bogo l'éléphant, Bambam le chien et Vak le canard — portent 100 % de jus de fruits mélangés avec vitamines A et C. Un jus sain, avec un jouet en prime.",
        highlights: [
          "100 % jus de fruits mélangés (pomme, fraise, prune)",
          "Enrichi en vitamine C et vitamine A",
          "Sans sucre ajouté, sans conservateurs, sans colorants artificiels",
          "Bouteilles-personnages à collectionner que les enfants adorent",
        ],
        variants: [
          "Kika — Bouteille singe",
          "Bogo — Bouteille éléphant",
          "Bambam — Bouteille chien",
          "Vak — Bouteille canard",
        ],
        heroSub: "Quatre personnages malicieux. Un jus sain.",
        attr1: "100 % jus de fruits",
        attr2: "Vitamine A + C",
        attr3: "Sans sucre ajouté",
        skuCount: "4 Personnages",
        skuFormat: "Bouteille personnage",
        skuUse: "À collectionner",
        family: {
          overline: "Rencontrez la famille",
          title: "Quatre amis. Un jus sain.",
          kika: { name: "Kika", animal: "Le Singe", body: "Malicieux, curieux, toujours prêt pour l'aventure. Kika apporte l'éclat de la fraise en tête." },
          bogo: { name: "Bogo", animal: "L'Éléphant", body: "Grand cœur, doux, et le calme de la bande. Bogo porte la profondeur prune-pomme." },
          bambam: { name: "Bambam", animal: "Le Chien", body: "Fidèle, joueur, et toujours prêt à recommencer. Bambam apporte une note pomme-fraise fraîche." },
          vak: { name: "Vak", animal: "Le Canard", body: "Éclaboussant, ensoleillé, et un brin malicieux. Vak, c'est la fête aux fruits mélangés en bouteille." },
        },
      },
      buzzer: {
        category: "Boisson énergétique",
        tagline: "performance maximale — concentration et productivité",
        story: "Buzzer vous fait tourner à plein régime. Le guarana libère sa caféine lentement et durablement ; les vitamines B soutiennent l'humeur. Pas de coup de fatigue — juste une combustion plus longue et plus propre. Pour une touche fonctionnelle, Buzzer Extra 5G associe un vrai jus de fruits à des acides aminés, de la L-théanine, du magnésium et de la vitamine C — probablement la canette énergisante la plus réfléchie en rayon.",
        highlights: [
          "Guarana + caféine de haute qualité — élan propre et durable",
          "Vigilance, concentration, mémoire et endurance accrues",
          "La boisson énergétique la plus appréciée de Türkiye depuis 25 ans",
          "Buzzer Extra 5G : 100 % jus pomme & mûre + acides aminés, L-théanine, complexe B et vitamine C",
        ],
        variants: [
          "Buzzer — Bouteille PET 1 L",
          "Buzzer — Canette 500 mL",
          "Buzzer — Canette 250 mL",
          "Buzzer Extra 5G — 150 mL · Pomme & Mûre",
        ],
      },
      multimalt: {
        category: "Boisson maltée",
        tagline: "élixir santé — augmente les hormones du bonheur",
        story: "Le malt d'orge brassé s'unit à un vrai jus de pomme et de mangue, puis se termine par des plantes traditionnelles depuis longtemps prisées par les jeunes mères. Multimalt Date associe le malt à la datte et à un complexe complet de vitamines B. Nourriture végétale, en canette.",
        highlights: [
          "100 % malt d'orge + vrai jus de fruits",
          "Plantes : fenouil, fenugrec, galéga, chardon béni",
          "B1, B2, B3, B5, B6, biotine, acide folique, B12",
          "Sans conservateurs, sans colorants, sans sucre ajouté",
        ],
        variants: [
          "Malt · Mangue · Pomme · Extraits de plantes",
          "Datte — Malt & jus de datte · complexe vitamines B",
        ],
        heroSub: "Malt d'orge + vrais fruits + plantes — en canette.",
        attr1: "Sans sucre ajouté",
        attr2: "Sans conservateurs",
        attr3: "8 vitamines B",
        skuCount: "2 Élixirs",
        skuFormat: "Canette 250 ml",
        skuUse: "Fruits + Malt",
        elixirs: {
          overline: "Les Deux Élixirs",
          title: "Deux recettes. Une tradition de nourriture naturelle.",
          mango: {
            name: "L'Élixir lumineux.",
            flavour: "Mangue · Pomme · Malt · Plantes",
            tag: "Nourriture au quotidien",
            body: "Malt d'orge, vrai jus de pomme et de mangue, agrémenté de fenouil, fenugrec, galéga et chardon béni — des plantes prisées par les jeunes mères depuis plus d'un siècle.",
            highlights: [
              "100 % malt d'orge + vrai jus de fruits",
              "Plantes : fenouil, fenugrec, galéga, chardon béni",
              "Sans conservateurs · sans colorants · sans sucre ajouté",
            ],
          },
          date: {
            name: "L'Élixir riche.",
            flavour: "Datte · Malt · Complexe complet vitamines B",
            tag: "Récupération & chaleur",
            body: "Malt d'orge marié au jus de datte — naturellement riche en fer, potassium et magnésium. Enrichi d'un complexe complet de vitamines B (B1, B2, B3, B5, B6, biotine, acide folique, B12).",
            highlights: [
              "Malt + jus de datte — fer & potassium naturels",
              "8 vitamines B essentielles dont l'acide folique",
              "Sans conservateurs · sans colorants · sans sucre ajouté",
            ],
          },
        },
        lifestyle: {
          caption: "La confiance des mères allaitantes depuis plus d'un siècle.",
          title: "La nourriture de la nature pour les jeunes mères.",
          body: "Multimalt puise sa force dans deux des ingrédients les plus fiables pour le bien-être maternel — le malt d'orge brassé et la datte riche — choisis pour la façon dont ils soutiennent les premiers mois exigeants de la maternité.",
          benefits: [
            { heading: "Malt d'orge", text: "Un galactagogue reconnu. Le malt d'orge est naturellement riche en bêta-glucane, associé à la libération de prolactine — l'hormone qui aide à maintenir une lactation saine. Il apporte aussi des glucides complexes à diffusion lente, du fer et des vitamines B qui aident à reconstituer l'énergie de la jeune mère heure après heure." },
            { heading: "Datte", text: "Un super-fruit nutritif pour la récupération. Les dattes sont riches en fer naturel, en potassium, en magnésium et en fibres — les nutriments les plus nécessaires après l'accouchement. Leurs sucres naturels offrent un regain d'énergie propre et durable sans sucre ajouté, tandis que leurs fibres soutiennent la digestion durant les semaines post-partum." },
          ],
        },
      },
      cafeo: {
        category: "Café glacé",
        tagline: "ralentit le temps — intime, doux et chaleureux",
        story: "Cafeo est un café 100 % Arabica infusé à la manière d'un barista — puis refroidi et mis en canette. Trois façons de le savourer : Dark Chocolate Truffle soyeux, Dulce de Leche caramel chaleureux et Dark Americano vif. Aucun raccourci.",
        highlights: [
          "100 % Arabica — infusé, pas en poudre",
          "Sans sucre · sans gluten · sans lactose",
          "Trois humeurs, trois canettes",
          "Prêt à boire, réfrigéré",
        ],
        variants: ["Dark Chocolate Truffle", "Dulce de Leche", "Dark Americano"],
        heroSub: "Infusé, refroidi, en canette. Trois humeurs.",
        attr1: "100 % Arabica",
        attr2: "Sans sucre",
        attr3: "Prêt à boire",
        skuCount: "3 Humeurs",
        skuFormat: "Canette 250 ml",
        skuUse: "Réfrigéré",
        moods: {
          overline: "Les Trois Humeurs",
          title: "Trois canettes. Trois façons de ralentir le temps.",
          darkChoc: {
            name: "Le sombre truffé.",
            flavour: "Dark Chocolate Truffle",
            body: "70 % cacao rencontre un Arabica infusé lentement. À siroter entre la réunion et la marche du retour.",
          },
          dulce: {
            name: "Le chaleureux.",
            flavour: "Dulce de Leche",
            body: "Lait caramélisé sur espresso infusé à froid. Presque un dessert. Presque.",
          },
          americano: {
            name: "Le shot droit.",
            flavour: "Dark Americano",
            body: "Sans sucre, sans lait. Juste un Arabica infusé, refroidi et en canette. La façon la plus claire d'entamer la journée.",
          },
        },
        moment: {
          overline: "Du grain à la canette",
          title: "Infusé lentement. Jamais pressé.",
          body: "Grains d'Arabica 100 %, infusés comme le ferait un barista — puis refroidis et mis en canette pour préserver le rituel. Trois humeurs sur une dalle de pierre : Dark Chocolate Truffle soyeux, Dulce de Leche chaleureux, Dark Americano tonique.",
          tag: "Cafeo · Café glacé infusé",
        },
      },
      aperina: {
        category: "Mélange apéritif",
        tagline: "un goût d'originalité incomparable",
        story: "Aperina est notre mélange à cocktail prêt à servir — notes de saveur originales, couleur inimitable, conçu pour l'instant où le barman ne veut pas réfléchir. Versez sur glace, complétez au soda, tranche d'orange en garniture. Coucher de soleil réussi.",
        highlights: [
          "Base de cocktail pétillant prête à servir",
          "Âme d'orange amère aigre-douce signature",
          "Couleur et goût inimitables",
          "Le service facile du barman",
        ],
        variants: ["Bouteille PET 1 L — Recette originale"],
        heroSub: "Un apéritif à recette unique, prêt à servir.",
        skuVolume: "1 L",
        skuFormat: "Bouteille PET",
        skuRecipe: "Recette originale",
        momentTitle: "Un rituel d'heure dorée.",
        steps: [
          "Remplissez un verre à vin de glace",
          "Versez Aperina, complétez avec du soda et l'alcool de votre choix",
          "Terminez par une tranche d'orange",
        ],
        momentCaption: "— Aperina, Recette originale. Servi avec glace, soda et orange.",
      },
      "white-elephant": {
        category: "Mixeur premium",
        tagline: "définit le raffinement — élégance et savoir-faire",
        story: "Pour les bars sérieux. Vraie quinine issue de l'écorce de FeverTree, vrai jus de citron dans le bitter lemon, et deux toniques premium — Japanese Yuzu pour la finesse des agrumes, Barbados Breeze pour un mélange plus chaud et tropical.",
        highlights: [
          "Tonique artisanal à la quinine naturelle",
          "Jusqu'à 85 mg de quinine issue de l'écorce FeverTree",
          "Faible en calories · qualité restaurant & bar",
          "Bouteille PET 1 L — format prêt pour le bar",
        ],
        variants: [
          "Tonique premium — Japanese Yuzu",
          "Tonique premium — Barbados Breeze",
          "Bitter Lemon",
        ],
        heroSub: "Mixeurs artisanaux, pensés pour les bars sérieux.",
        attr1: "Quinine naturelle",
        attr2: "Faibles calories",
        attr3: "Qualité bar",
        skuVolume: "1 L",
        skuFormat: "Bouteille PET",
        skuRange: "3 Recettes",
        triptych: {
          overline: "Trois toniques, trois instants",
          title: "La sélection du barman.",
          yuzu: {
            name: "Tonique Japanese Yuzu",
            pairing: "Idéal avec un gin",
            steps: [
              "Remplissez un highball de glaçons",
              "Versez 45 ml de gin, complétez au Yuzu tonique",
              "Garnissez d'une feuille de shiso ou d'un zeste de citron",
            ],
          },
          barbados: {
            name: "Tonique Barbados Breeze",
            pairing: "Idéal avec un rhum blanc vieilli",
            steps: [
              "Remplissez une coupe de glace pilée",
              "Versez 45 ml de rhum blanc vieilli, complétez au Barbados Breeze",
              "Terminez par un zeste de pamplemousse rose",
            ],
          },
          bitter: {
            name: "Bitter Lemon",
            pairing: "Idéal avec du gin ou de la vodka",
            steps: [
              "Remplissez un highball de glaçons",
              "Versez 45 ml de gin ou de vodka, complétez au Bitter Lemon",
              "Garnissez d'un zeste de citron et d'une branche de menthe",
            ],
          },
        },
        moments: {
          overline: "Moments White Elephant",
          title: "Là où le raffinement rencontre le service.",
          bitter: {
            title: "Le tranchant lumineux.",
            body: "Bitter Lemon parmi les agrumes méditerranéens — vrai jus de citron, quinine naturelle et cette pointe fraîche qui sublime un highball ou un G&T.",
            tag: "Bitter Lemon",
          },
          tonics: {
            title: "Le service premium.",
            body: "Japanese Yuzu pour la finesse des agrumes. Barbados Breeze pour la chaleur tropicale. Deux toniques, un savoir-faire de bar — servis sur glace avec un brin de romarin.",
            tag: "Japanese Yuzu · Barbados Breeze",
          },
        },
      },
      desser: {
        category: "Sauces & Sirops",
        tagline: "incarne la créativité — brise toutes les règles de la douceur",
        story: "Desser est le trait final — six profils de saveur pensés pour baristas, mixologues et pâtissiers. De De Mer Whisper (caramel salé) à Belgravia Celestial (chocolat blanc, pistache, banane).",
        highlights: [
          "Sauces & sirops de qualité chef",
          "Profils fruités · torréfiés · profonds · exotiques",
          "Texture pleine, richesse en bouche",
          "Bouteille + système de pompe innovants",
        ],
        variants: [
          "De Mer Whisper — Caramel salé",
          "Madagascar Charm — Vanille · Framboise",
          "Peruvian Noir — Chocolat noir truffé",
          "Ivory Pearl — Chocolat blanc · Macadamia",
          "Belgravia Celestial — Chocolat blanc · Pistache · Banane",
          "Silken Mist — Dulce de Leche · Amande",
        ],
        heroSub: "Six signatures. Élaborées avec dévotion.",
        attr1: "Qualité chef",
        attr2: "Texture pleine",
        attr3: "Système à pompe",
        skuCount: "6 Recettes",
        skuFormat: "Bouteille PET",
        skuUse: "Café · Cocktail · Pâtisserie",
        signatures: {
          overline: "Les Six Signatures",
          title: "Six saveurs. Six moments à composer.",
          deMer: {
            name: "De Mer Whisper",
            flavour: "Caramel salé",
            body: "Un murmure de sel marin sur un caramel longuement mijoté. Versé sur un whisky sour ou un flat white bien corsé.",
          },
          madagascar: {
            name: "Madagascar Charm",
            flavour: "Vanille · Framboise",
            body: "Vanille bourbon mariée à l'éclat de la framboise. Un service maison pour spritzes et French 75.",
          },
          peruvian: {
            name: "Peruvian Noir",
            flavour: "Chocolat noir truffé",
            body: "70 % de cacao et une profondeur de truffe. Transforme un moka en instant, un fondant en souvenir.",
          },
          ivory: {
            name: "Ivory Pearl",
            flavour: "Chocolat blanc · Macadamia",
            body: "Chocolat blanc soyeux et chaleur de la macadamia torréfiée. Se dépose en ruban sur cheesecake et gelato.",
          },
          belgravia: {
            name: "Belgravia Celestial",
            flavour: "Choc blanc · Pistache · Banane",
            body: "La composition la plus théâtrale de la maison. Pistache-banane sur chocolat blanc crémeux — conçue pour les desserts en couches.",
          },
          silken: {
            name: "Silken Mist",
            flavour: "Dulce de Leche · Amande",
            body: "Lait caramélisé et douceur d'amande grillée. Une signature pour lattes, tiramisus et longs après-midis.",
          },
        },
      },
    },
    nav: {
      brands: "Marques", about: "À propos", sustainability: "Durabilité",
      b2b: "B2B", contact: "Contact", cta: "Devenir Partenaire",
      sample: "Demander des échantillons", distributors: "Distributeurs",
    },
    hero: {
      overline: "Producteur turc de marques de boissons et alimentaires",
      the: "le", tasteOf: "goût de", living: "bien", well: "vivre.",
      subtitle: "De la Turquie au monde depuis 1998 — une famille de marques bâtie pour celles et ceux qui aiment ce qu'ils boivent, mangent et partagent.",
      exploreBrands: "Découvrir nos marques", talkTrade: "Parler affaires",
    },
    about: {
      title: "À PROPOS",
      body1: "est née d'une conviction simple mais puissante : la nourriture et la boisson ne sont pas de simples produits — ce sont des expériences qui rassemblent les gens.",
      body2: "Dès l'origine, notre but a été de créer une communauté mondiale du goût ; qui mêle qualité, curiosité et émotion à chaque instant du quotidien. Aujourd'hui, sous l'ombrelle Hupla,",
      body3: "forment une vibrante famille de marques — chacune raconte sa propre histoire, chacune évoque un même sentiment de joie.",
    },
    brands: {
      title: "PLUS QU'UNE MAISON DE MARQUES",
      subtitle: "Chacune de nos marques reflète un rythme de vie différent",
      portfolio: "Portefeuille", of: "/", dragSwipe: "Glisser / Faire défiler",
      exploreBrand: "Explorer", ourBrands: "NOS MARQUES",
      livingCulture: "Une culture vivante",
      manifesto1: "Chaque verre, chaque gorgée, chaque saveur raconte une histoire — des mains, des récoltes, du foyer.",
      manifesto2: "D'İstanbul à Riyad, de Lagos à Londres — Hupla, c'est la joie de bien vivre, partagée.",
      cities: "D'İstanbul à Riyad, de Lagos à Londres.",
    },
    sustainability: {
      title: "DURABILITÉ",
      quote: "Pour nous, la durabilité n'est pas un objectif — c'est une manière de vivre.",
      body: "Chaque étape de la production Hupla — de l'approvisionnement en matières premières à l'emballage — est guidée par un engagement responsable. Sucre réduit, recettes végétales, emballages recyclables et étiquettes honnêtes ne sont pas des options — c'est notre base.",
    },
    group: {
      kicker: "Membre du Groupe",
      title: "Adossé à une holding d'investissement suisse.",
      body: "Hupla est la société de production de boissons et d'alimentation du portefeuille de De Almeda Seligmann Capital AG — une holding d'investissement suisse basée à Zoug qui gère ses marques de boissons turques avec une vision multigénérationnelle à long terme. Par la gouvernance suisse et le savoir-faire turc, elle poursuit des investissements et une croissance ambitieux à l'échelle mondiale.",
      cta: "dealmedaseligmann.ch",
      pillars: {
        swiss: { title: "Gouvernance suisse", body: "Enregistrée à Zoug, tenue à des standards institutionnels de transparence et de reporting." },
        long:  { title: "Opérateur de long terme", body: "Capitaux patients qui pensent en générations, pas en trimestres — c'est ainsi que se construisent les marques de boissons." },
        global:{ title: "Portée mondiale", body: "Fabrication ancrée en Turquie, ambition de distribution en Europe, au MENA et au-delà." },
      },
    },
    b2b: {
      overline: "Demandes B2B",
      titleA: "Amener Hupla", titleB: "sur votre", titleC: "marché", titleDot: ".",
      subtitle: "Distributeurs, importateurs, chaînes et opérateurs horeca — dites-nous où vous êtes et quelles marques vous voulez sur vos étagères. Notre équipe export répond aux demandes sérieuses sous 2 jours ouvrés.",
      bullet1: "Portefeuille complet + fiches produits",
      bullet2: "MOQ flexibles & mélange conteneur",
      bullet3: "Options MDD sur lignes sélectionnées",
      bullet4: "Support marketing & PLV sur le marché",
      lblFullName: "Nom complet *", lblCompany: "Société *", lblEmail: "Email pro *",
      lblPhone: "Téléphone", lblCountry: "Pays / marché *", lblBrand: "Marque d'intérêt",
      lblInquiryType: "Type de demande", lblMessage: "Parlez-nous de votre activité *",
      phFullName: "Jean Dupont", phCompany: "Global Beverages SAS", phEmail: "jean@societe.com",
      phPhone: "+33 1 23 45 67 89", phCountry: "France", phBrandAny: "Toutes",
      phMessage: "Volumes attendus, portefeuille actuel, canaux ciblés…",
      typeDistribution: "Distribution / Import", typeHoreca: "Horeca / CHR",
      typePrivate: "MDD / Co-fabrication", typeRetail: "Retail / GD", typeOther: "Autre",
      submit: "Envoyer la demande", sending: "Envoi…",
      privacy: "En envoyant, vous acceptez d'être contacté par Hupla concernant votre demande. Nous ne partageons pas vos données.",
      successTitle: "Demande reçue.",
      successBody: "Merci. Notre équipe export répondra sous 2 jours ouvrés.",
      errorFallback: "Une erreur est survenue. Veuillez réessayer.",
      portfolioOverline: "Emportez-le avec vous",
      portfolioTitle: "Le portfolio de marques Hupla 2026.",
      portfolioBody: "13 pages de spécifications produits, notes de positionnement et visuels clés pour chaque marque — Buzzer, Mamm, Multimalt, Cafeo, Aperina, White Elephant et Desser.",
      portfolioBullet1: "Formats, tailles et MOQ réels",
      portfolioBullet2: "Positionnement, consommateur cible et canal",
      portfolioBullet3: "Photographies produit validées, prêtes pour vos présentations",
      portfolioHint: "Obtenez le PDF prêt à imprimer ↓",
      portfolioReady: "Votre portfolio de marques 2026 est prêt.",
      portfolioDownload: "Télécharger le PDF (2,9 Mo)",
    },
    contact: {
      overline: "Contact", titleA: "Dites bonjour,", titleCity: "İstanbul", titleB: "est à l'écoute.",
      subtitle: "Notre siège à Şişli, İstanbul est le centre névralgique de Hupla. Contactez-nous pour partenariats, presse, carrières ou juste un bonjour.",
      headquarters: "Siège social", office: "Bureau", mobile: "Mobile", email: "Email",
    },
    footer: {
      overline: "Hupla", titleJoy: "La joie", titleRest: "de bien vivre.",
      desc: "Producteur turc de boissons et produits alimentaires premium, élaborés sous notre propre famille de marques pour la Türkiye et l'export depuis 1998.",
      navigate: "Navigation", ourBrands: "Nos Marques",
      linkHome: "Accueil", linkAbout: "À propos", linkBrands: "Marques",
      linkSustainability: "Durabilité", linkB2B: "Demande B2B", linkContact: "Contact",
      groupCompany: "Filiale du groupe",
      groupTagline: "Holding d'investissement suisse basée à Zoug — notre actionnaire de long terme.",
      headOffice: "Siège",
      copyright: "Tous droits réservés.",
      crafted: "Fabriqué avec soin à İstanbul, Türkiye.",
    },
    brandPage: {
      backHome: "Retour aux marques", partnerCta: "Devenir Partenaire",
      whatMakes: "Ce qui la rend spéciale", closerLook: "De plus près,",
      availableIn: "Disponible en", productLine: "La gamme",
      sideBySide: "Chaque {name}, côte à côte.",
      skus: "SKUs", fromDeck: "Depuis la présentation {name}",
      pages: "pages", exploreOther: "Découvrir d'autres marques",
    },
    shows: {
      kicker: "Salons professionnels 2026",
      title: "Retrouvez-nous sur le salon.",
      body: "Réservez votre rendez-vous à l'avance pour un créneau de dégustation privée avec notre équipe export. Nos coffrets d'échantillons voyagent avec nous à chaque salon.",
      book: "Réserver un rendez-vous",
      showcasing: "Marques exposées",
    },
    dist: {
      portalOverline: "Portail Distributeur",
      signInTitle: "Connexion.",
      emailPh: "E-mail",
      passwordPh: "Mot de passe",
      signInBtn: "Se connecter",
      signingIn: "Connexion…",
      newDist: "Nouveau distributeur ?",
      registerLink: "S'inscrire →",
      useAdminLogin: "Veuillez utiliser la connexion administrateur.",
      loginFailed: "Échec de la connexion",
      registerTitle: "Devenez partenaire Hupla.",
      registerSub: "Dites-nous qui vous êtes et quel territoire vous couvrez — nous activerons votre portail immédiatement.",
      phName: "Nom complet *",
      phCompany: "Société *",
      phEmail: "E-mail professionnel *",
      phPassword: "Mot de passe (8 car. min.) *",
      territoryLabel: "Territoire",
      phArea: "Zone / région *",
      phCity: "Ville *",
      phCountry: "Pays *",
      createBtn: "Créer le compte",
      creating: "Création du compte…",
      alreadyRegistered: "Déjà inscrit ?",
      signInLink: "Se connecter →",
      welcomeToast: "Bienvenue chez Hupla — votre compte distributeur est actif.",
      regFailed: "Échec de l'inscription",
      welcome: "Bienvenue, {name}.",
      signOut: "Se déconnecter",
      yourTerritory: "Votre territoire",
      colCompany: "Société",
      colArea: "Zone",
      colCity: "Ville",
      colCountry: "Pays",
      partnerResources: "Ressources partenaires",
      res1Title: "Portfolio de marques 2026",
      res1Body: "Le deck de présentation complet en 300 dpi — les sept marques avec spécifications produits et tailles de cartons.",
      res1Action: "Télécharger le PDF",
      res2Title: "Demander des échantillons physiques",
      res2Body: "Commandez des caisses d'échantillons expédiées à votre entrepôt — nous couvrons le transport pour les distributeurs intégrés.",
      res2Action: "Demander des échantillons",
      res3Title: "Rendez-vous sur les salons",
      res3Body: "Gulfood · Anuga · SIAL Paris 2026. Réservez un créneau de dégustation privée avec notre équipe export.",
      res3Action: "Réserver un rendez-vous",
      helpMail: "Besoin d'aide ? Contactez export@hupla.world",
    },
    ageGate: {
      overline: "Vérification d'âge",
      title: "Vous devez avoir 18 ans ou plus pour entrer.",
      body: "Cette section contient du contenu relatif à des boissons alcoolisées. Veuillez confirmer que vous êtes en âge légal de consommer de l'alcool dans votre pays.",
      yes: "J'ai 18 ans ou plus",
      no: "J'ai moins de 18 ans",
      rejectedBody: "Désolé — vous devez avoir 18 ans ou plus pour voir ce contenu.",
      goHome: "Retour à l'accueil",
      footer: "À consommer avec modération. Ne pas partager avec des personnes n'ayant pas l'âge légal.",
    },
    we: {
      moreCocktails: {
        overline: "La suite du bar",
        title: "Six autres avec White Elephant.",
        yuzuSour: {
          pairing: "Yuzu · vodka",
          name: "Yuzu Sour",
          recipe: "45 ml de vodka · 15 ml de citron · complétez avec Yuzu Tonic · mousse de blanc d'œuf · zeste de yuzu.",
        },
        goldenHighball: {
          pairing: "Yuzu · whisky japonais",
          name: "Golden Highball",
          recipe: "45 ml de whisky japonais · gros glaçon · complétez avec Yuzu Tonic · zeste de citron.",
        },
        pinkPaloma: {
          pairing: "Barbados · tequila blanche",
          name: "Pink Paloma",
          recipe: "45 ml de tequila blanche · pincée de sel · complétez avec Barbados Breeze · quartier de pamplemousse.",
        },
        caribbeanSpritz: {
          pairing: "Barbados · rhum ambré + prosecco",
          name: "Caribbean Spritz",
          recipe: "30 ml de rhum ambré · 60 ml de prosecco · complétez avec Barbados Breeze · zeste d'orange.",
        },
        sicilianGT: {
          pairing: "Bitter Lemon · gin méditerranéen",
          name: "Sicilian G&T",
          recipe: "45 ml de gin méditerranéen · brin de romarin · complétez avec Bitter Lemon · rondelle de citron.",
        },
        vodkaBitter: {
          pairing: "Bitter Lemon · vodka",
          name: "Cucumber Bitter",
          recipe: "45 ml de vodka · 3 rubans de concombre · complétez avec Bitter Lemon · brin de menthe.",
        },
      },
    },
    sample: {
      kicker: "Demande d'échantillons",
      title: "Testez avant de référencer.",
      sub: "Dites-nous où livrer et quelles marques inclure — le transport est à notre charge pour les comptes sérieux.",
      phName: "Nom complet *",
      phCompany: "Société *",
      phEmail: "E-mail professionnel *",
      phPhone: "Téléphone",
      phCountry: "Pays / marché *",
      phAddress: "Adresse de livraison *",
      brandsLabel: "Marques à inclure *",
      phNotes: "Notes (facultatif)",
      submit: "Demander des échantillons",
      sending: "Envoi…",
      thanks: "Les échantillons sont en route.",
      thanksBody: "Notre équipe export confirmera votre adresse de livraison sous 2 jours ouvrés et expédiera les échantillons dans la foulée.",
      close: "Fermer",
      errNoBrand: "Veuillez choisir au moins une marque",
      errServer: "Une erreur est survenue. Veuillez réessayer.",
      success: "Demande d'échantillons reçue — nous vous recontacterons.",
    },
  },

  ru: {
    brandContent: {
      mamm: {
        category: "Детский сок",
        tagline: "уловил суть природы — чистый, гармоничный, честный",
        story: "Mamm превращает утоление жажды в игру. Четыре забавных персонажа — обезьянка Кика, слоник Бого, собачка Бамбам и уточка Вак — несут 100% смешанный фруктовый сок с витаминами A и C. Полезный сок с игрушкой сверху.",
        highlights: [
          "100% смешанный фруктовый сок (яблоко, клубника, слива)",
          "Обогащён витаминами C и A",
          "Без сахара, консервантов и искусственных красителей",
          "Коллекционные бутылочки-персонажи, которые обожают дети",
        ],
        variants: [
          "Кика — бутылочка «Обезьянка»",
          "Бого — бутылочка «Слон»",
          "Бамбам — бутылочка «Собачка»",
          "Вак — бутылочка «Уточка»",
        ],
        heroSub: "Четыре озорных персонажа. Один полезный сок.",
        attr1: "100% фруктовый сок",
        attr2: "Витамины A + C",
        attr3: "Без добавленного сахара",
        skuCount: "4 персонажа",
        skuFormat: "Бутылочка-персонаж",
        skuUse: "Коллекционная",
        family: {
          overline: "Познакомьтесь с семьёй",
          title: "Четыре друга. Один полезный сок.",
          kika: { name: "Кика", animal: "Обезьянка", body: "Озорная, любопытная, всегда в настроении для приключений. Кика приносит клубничную яркость." },
          bogo: { name: "Бого", animal: "Слонёнок", body: "Большое сердце, нежный и самый спокойный из компании. Бого несёт сливово-яблочную глубину." },
          bambam: { name: "Бамбам", animal: "Собачка", body: "Верный, игривый, всегда готовый на новый заход. Бамбам приносит свежую яблочно-клубничную ноту." },
          vak: { name: "Вак", animal: "Уточка", body: "Плещущийся, солнечный и слегка озорной. Вак — это вечеринка смешанных фруктов в бутылке." },
        },
      },
      buzzer: {
        category: "Энергетический напиток",
        tagline: "пик формы — острый фокус и продуктивность",
        story: "Buzzer помогает работать на всю мощность. Гуарана отдаёт кофеин медленно и стабильно; витамины группы B поддерживают настроение. Без резкого спада — только более длительная и чистая энергия. Buzzer Extra 5G сочетает настоящий фруктовый сок с аминокислотами, L-Теанином, магнием и витамином C — вероятно, самая продуманно составленная банка энергетика на полке.",
        highlights: [
          "Гуарана + качественный кофеин — чистый, устойчивый подъём",
          "Внимание, фокус, память и выносливость",
          "25 лет любимый в Турции энергетик",
          "Buzzer Extra 5G: 100% сок яблока и шелковицы + аминокислоты, L-Теанин, комплекс B и витамин C",
        ],
        variants: [
          "Buzzer — ПЭТ бутылка 1 л",
          "Buzzer — банка 500 мл",
          "Buzzer — банка 250 мл",
          "Buzzer Extra 5G — 150 мл · яблоко & шелковица",
        ],
      },
      multimalt: {
        category: "Солодовый напиток",
        tagline: "эликсир здоровья — повышает гормоны счастья",
        story: "Сваренный ячменный солод соединяется с натуральным яблочным и манговым соком и завершается традиционными травами, которым давно доверяют кормящие матери. Multimalt Date сочетает солод с финиками и полным комплексом витаминов B. Растительное питание в банке.",
        highlights: [
          "100% ячменный солод + настоящий фруктовый сок",
          "Травы: фенхель, пажитник, козлятник, расторопша",
          "B1, B2, B3, B5, B6, биотин, фолиевая кислота, B12",
          "Без консервантов, красителей и добавленного сахара",
        ],
        variants: [
          "Солод · Манго · Яблоко · Растительные экстракты",
          "Финик — солод & финиковый сок · комплекс B",
        ],
        heroSub: "Ячменный солод + настоящие фрукты + травы — в банке.",
        attr1: "Без добавленного сахара",
        attr2: "Без консервантов",
        attr3: "8 витаминов B",
        skuCount: "2 эликсира",
        skuFormat: "Банка 250 мл",
        skuUse: "Фрукты + солод",
        elixirs: {
          overline: "Два Эликсира",
          title: "Два рецепта. Одна традиция природного питания.",
          mango: {
            name: "Светлый эликсир.",
            flavour: "Манго · Яблоко · Солод · Травы",
            tag: "Ежедневное питание",
            body: "Ячменный солод с настоящим яблочным и манговым соком, завершённый фенхелем, пажитником, козлятником и расторопшей — травами, которым кормящие матери доверяют более века.",
            highlights: [
              "100% ячменный солод + настоящий фруктовый сок",
              "Травы: фенхель, пажитник, козлятник, расторопша",
              "Без консервантов · без красителей · без добавленного сахара",
            ],
          },
          date: {
            name: "Богатый эликсир.",
            flavour: "Финик · Солод · Полный комплекс витаминов B",
            tag: "Восстановление и тепло",
            body: "Ячменный солод в союзе с финиковым соком — от природы богат железом, калием и магнием. Обогащён полным B-комплексом (B1, B2, B3, B5, B6, биотин, фолиевая кислота, B12).",
            highlights: [
              "Солод + финиковый сок — натуральное железо и калий",
              "8 необходимых витаминов B, включая фолиевую кислоту",
              "Без консервантов · без красителей · без добавленного сахара",
            ],
          },
        },
        lifestyle: {
          caption: "Более века доверия кормящих матерей.",
          title: "Природная забота для молодых мам.",
          body: "Multimalt черпает силу из двух ингредиентов, наиболее ценимых в материнском благополучии — сваренного ячменного солода и питательных фиников — выбранных за их поддержку в самые требовательные первые месяцы материнства.",
          benefits: [
            { heading: "Ячменный солод", text: "Проверенный временем галактагог. Ячменный солод от природы богат бета-глюканом, связанным с выработкой пролактина — гормона, поддерживающего здоровую лактацию. Он также обеспечивает медленные сложные углеводы, железо и витамины группы B, которые час за часом восстанавливают силы кормящей матери." },
            { heading: "Финики", text: "Питательный суперфрукт для восстановления. Финики богаты натуральным железом, калием, магнием и клетчаткой — нутриентами, наиболее необходимыми после родов. Их натуральные сахара обеспечивают чистый, продолжительный подъём энергии без добавленного сахара, а клетчатка поддерживает пищеварение в послеродовые недели." },
          ],
        },
      },
      cafeo: {
        category: "Холодный кофе",
        tagline: "замедляет время — уютный, тёплый и близкий",
        story: "Cafeo — это 100% Арабика, сваренная как это делает бариста, затем охлаждённая и упакованная в банку. Три варианта: шелковистый Dark Chocolate Truffle, тёплый карамельный Dulce de Leche и бодрящий Dark Americano. Без компромиссов.",
        highlights: [
          "100% Арабика — сваренная, не порошок",
          "Без сахара · без глютена · без лактозы",
          "Три настроения, три банки",
          "Готов к употреблению, охлаждён",
        ],
        variants: ["Dark Chocolate Truffle", "Dulce de Leche", "Dark Americano"],
        heroSub: "Сварено, охлаждено, упаковано. Три настроения.",
        attr1: "100% Арабика",
        attr2: "Без сахара",
        attr3: "Готов к употреблению",
        skuCount: "3 настроения",
        skuFormat: "Банка 250 мл",
        skuUse: "Охлаждён",
        moods: {
          overline: "Три настроения",
          title: "Три банки. Три способа замедлить время.",
          darkChoc: {
            name: "Тёмный, с трюфелем.",
            flavour: "Dark Chocolate Truffle",
            body: "70% какао встречают медленно сваренную Арабику. Идеально между встречей и дорогой домой.",
          },
          dulce: {
            name: "Тёплый.",
            flavour: "Dulce de Leche",
            body: "Карамелизованное молоко поверх холодного эспрессо. Почти десерт. Почти.",
          },
          americano: {
            name: "Прямой удар.",
            flavour: "Dark Americano",
            body: "Без сахара, без молока. Просто сваренная Арабика, охлаждённая и упакованная. Самый ясный способ начать день.",
          },
        },
        moment: {
          overline: "От зерна к банке",
          title: "Медленно сварено. Без спешки.",
          body: "100% зёрен Арабики, сваренных как это делает бариста — затем охлаждённых и упакованных, чтобы ритуал сохранился. Три настроения на каменной плите: шелковистый Dark Chocolate Truffle, тёплый Dulce de Leche, бодрящий Dark Americano.",
          tag: "Cafeo · Сваренный холодный кофе",
        },
      },
      aperina: {
        category: "Аперитивный микс",
        tagline: "непревзойдённый вкус оригинальности",
        story: "Aperina — наш готовый коктейльный микс: оригинальные ноты вкуса, узнаваемый цвет, создан для моментов, когда бармену не хочется думать. Налейте на лёд, долейте содовую, украсьте долькой апельсина. Закат готов.",
        highlights: [
          "Готовая основа для игристых коктейлей",
          "Фирменная горько-сладкая нота горького апельсина",
          "Неповторимый цвет и вкус",
          "Простой розлив для бармена",
        ],
        variants: ["ПЭТ бутылка 1 л — оригинальная рецептура"],
        heroSub: "Аперитив по единственному рецепту — готов к подаче.",
        skuVolume: "1 л",
        skuFormat: "ПЭТ-бутылка",
        skuRecipe: "Оригинальная рецептура",
        momentTitle: "Ритуал золотого часа.",
        steps: [
          "Наполните бокал для вина льдом",
          "Влейте Aperina, долейте содовой и предпочитаемым крепким алкоголем",
          "Украсьте долькой апельсина",
        ],
        momentCaption: "— Aperina, оригинальная рецептура. Со льдом, содовой и апельсином.",
      },
      "white-elephant": {
        category: "Премиум-миксер",
        tagline: "воплощает утончённость — грация и мастерство",
        story: "Для серьёзных баров. Настоящий хинин из коры FeverTree, настоящий лимонный сок в bitter lemon и два премиальных тоника — Japanese Yuzu для цитрусовой изящности и Barbados Breeze для тёплого, тропического микса.",
        highlights: [
          "Ремесленный тоник с натуральным хинином",
          "До 85 мг хинина из коры FeverTree",
          "Низкокалорийный · ресторанного и барного уровня",
          "ПЭТ 1 л — формат готовый для бара",
        ],
        variants: [
          "Премиум-тоник — Japanese Yuzu",
          "Премиум-тоник — Barbados Breeze",
          "Bitter Lemon",
        ],
        heroSub: "Ремесленные миксеры, созданные для серьёзных баров.",
        attr1: "Натуральный хинин",
        attr2: "Низкокалорийный",
        attr3: "Барный уровень",
        skuVolume: "1 л",
        skuFormat: "ПЭТ-бутылка",
        skuRange: "3 рецепта",
        triptych: {
          overline: "Три тоника, три момента",
          title: "Список бармена.",
          yuzu: {
            name: "Тоник Japanese Yuzu",
            pairing: "Лучше всего с джином",
            steps: [
              "Наполните хайбол кубиками льда",
              "Влейте 45 мл джина, долейте тоник Yuzu",
              "Украсьте листом сисо или цедрой лимона",
            ],
          },
          barbados: {
            name: "Тоник Barbados Breeze",
            pairing: "Лучше всего с выдержанным белым ромом",
            steps: [
              "Наполните бокал копа колотым льдом",
              "Влейте 45 мл выдержанного белого рома, долейте Barbados Breeze",
              "Завершите цедрой розового грейпфрута",
            ],
          },
          bitter: {
            name: "Bitter Lemon",
            pairing: "Лучше всего с джином или водкой",
            steps: [
              "Наполните хайбол кубиками льда",
              "Влейте 45 мл джина или водки, долейте Bitter Lemon",
              "Украсьте цедрой лимона и веточкой мяты",
            ],
          },
        },
        moments: {
          overline: "Моменты White Elephant",
          title: "Там, где утончённость встречает подачу.",
          bitter: {
            title: "Яркая грань.",
            body: "Bitter Lemon среди средиземноморских цитрусовых — настоящий лимонный сок, натуральный хинин и та свежая нотка, что оживляет хайбол или джин-тоник.",
            tag: "Bitter Lemon",
          },
          tonics: {
            title: "Премиальная подача.",
            body: "Japanese Yuzu для цитрусовой изящности. Barbados Breeze для тропической теплоты. Два тоника, одно барное мастерство — подаётся со льдом и веточкой розмарина.",
            tag: "Japanese Yuzu · Barbados Breeze",
          },
        },
      },
      desser: {
        category: "Соусы и сиропы",
        tagline: "воплощает творчество — ломает все правила сладости",
        story: "Desser — финальный мазок кисти: шесть вкусовых профилей для бариста, миксологов и кондитеров. От De Mer Whisper (солёная карамель) до Belgravia Celestial (белый шоколад, фисташка, банан).",
        highlights: [
          "Соусы и сиропы шеф-уровня",
          "Фруктовые · ореховые · глубокие · экзотические профили",
          "Плотная текстура, богатое послевкусие",
          "Инновационная бутылка + система помпы",
        ],
        variants: [
          "De Mer Whisper — солёная карамель",
          "Madagascar Charm — ваниль · framboise",
          "Peruvian Noir — тёмный шоколад трюфель",
          "Ivory Pearl — белый шоколад · макадамия",
          "Belgravia Celestial — белый шоколад · фисташка · банан",
          "Silken Mist — Dulce de Leche · миндаль",
        ],
        heroSub: "Шесть подписей. Небесно созданные.",
        attr1: "Шеф-класса",
        attr2: "Полнотелые",
        attr3: "С помпой",
        skuCount: "6 рецептов",
        skuFormat: "ПЭТ-бутылка",
        skuUse: "Кофе · Коктейль · Кондитерка",
        signatures: {
          overline: "Шесть Подписей",
          title: "Шесть вкусов. Шесть моментов, чтобы сочинить.",
          deMer: {
            name: "De Mer Whisper",
            flavour: "Солёная карамель",
            body: "Шёпот морской соли поверх медленно томлёного ириса. Подаётся к whisky sour или насыщенному флэт-уайту.",
          },
          madagascar: {
            name: "Madagascar Charm",
            flavour: "Ваниль · Малина",
            body: "Ваниль бурбон в союзе с яркостью малины. Домашняя подача для спритц и French 75.",
          },
          peruvian: {
            name: "Peruvian Noir",
            flavour: "Тёмный шоколад трюфель",
            body: "70% какао с трюфельной глубиной. Превращает мокко в момент, фондан — в воспоминание.",
          },
          ivory: {
            name: "Ivory Pearl",
            flavour: "Белый шоколад · Макадамия",
            body: "Шелковистый белый шоколад с теплотой обжаренной макадамии. Красиво ложится лентой на чизкейк и джелато.",
          },
          belgravia: {
            name: "Belgravia Celestial",
            flavour: "Белый шоколад · Фисташка · Банан",
            body: "Самая театральная композиция дома. Фисташка и банан на сливочном белом шоколаде — создана для слоёных десертов.",
          },
          silken: {
            name: "Silken Mist",
            flavour: "Dulce de Leche · Миндаль",
            body: "Карамелизованное молоко с мягкостью обжаренного миндаля. Подпись для латте, тирамису и неспешных послеполуденных часов.",
          },
        },
      },
    },
    nav: {
      brands: "Бренды", about: "О нас", sustainability: "Экоответственность",
      b2b: "B2B", contact: "Контакты", cta: "Стать партнёром",
      sample: "Заказать образцы", distributors: "Дистрибьюторы",
    },
    hero: {
      overline: "Турецкий производитель напитков и продуктов питания",
      the: "вкус", tasteOf: "хорошей", living: "жизни.", well: "",
      subtitle: "Из Турции в мир с 1998 года — семья брендов для тех, кому важно, что они пьют, едят и с кем делятся.",
      exploreBrands: "Наши бренды", talkTrade: "Партнёрство",
    },
    about: {
      title: "О НАС",
      body1: "рождена из простого, но сильного убеждения: еда и напитки — это не просто продукты, это переживания, которые объединяют людей.",
      body2: "С самого начала наша цель — создать глобальное сообщество вкуса, соединяющее качество, любопытство и эмоцию в каждый момент повседневной жизни. Сегодня под зонтиком Hupla",
      body3: "образуют живую семью брендов — каждый со своей историей, каждый рождает общее чувство радости.",
    },
    brands: {
      title: "БОЛЬШЕ, ЧЕМ ДОМ БРЕНДОВ",
      subtitle: "Каждый из наших брендов отражает свой ритм жизни",
      portfolio: "Портфолио", of: "из", dragSwipe: "Проведите / Свайп",
      exploreBrand: "Открыть", ourBrands: "НАШИ БРЕНДЫ",
      livingCulture: "Живая культура",
      manifesto1: "Каждый бокал, каждый глоток, каждый вкус рассказывает историю — рук, урожая, дома.",
      manifesto2: "От Стамбула до Эр-Рияда, от Лагоса до Лондона — Hupla это радость жить хорошо, разделённая.",
      cities: "От Стамбула до Эр-Рияда, от Лагоса до Лондона.",
    },
    sustainability: {
      title: "ЭКООТВЕТСТВЕННОСТЬ",
      quote: "Для нас устойчивость — не цель, а образ жизни.",
      body: "Каждый шаг производства Hupla — от закупки сырья до упаковки — руководствуется ответственностью. Меньше сахара, растительные рецепты, перерабатываемая упаковка и честные этикетки — это не дополнение, это наша основа.",
    },
    group: {
      kicker: "Часть Группы",
      title: "При поддержке швейцарского инвестиционного холдинга.",
      body: "Hupla — компания по производству напитков и продуктов питания в портфеле De Almeda Seligmann Capital AG, швейцарского инвестиционного холдинга со штаб-квартирой в Цуге, который управляет турецкими напитковыми брендами с долгосрочным, многопоколенческим горизонтом. Швейцарским управлением и турецким мастерством группа поддерживает свои амбициозные глобальные инвестиции и рост.",
      cta: "dealmedaseligmann.ch",
      pillars: {
        swiss: { title: "Швейцарское управление", body: "Зарегистрирован в Цуге, соответствует институциональным стандартам прозрачности и отчётности." },
        long:  { title: "Долгосрочный оператор", body: "Терпеливый капитал, мыслящий поколениями, а не кварталами — так и должны строиться напитковые бренды." },
        global:{ title: "Глобальный охват", body: "Производство укоренено в Турции, амбиции дистрибуции — Европа, MENA и далее." },
      },
    },
    b2b: {
      overline: "B2B-запросы",
      titleA: "Приведите Hupla", titleB: "на ваш", titleC: "рынок", titleDot: ".",
      subtitle: "Дистрибьюторам, импортёрам, розничным сетям и HoReCa — расскажите, где вы и какие бренды хотите видеть на своих полках. Экспортная команда отвечает на серьёзные запросы в течение 2 рабочих дней.",
      bullet1: "Полный портфель + техпаспорта",
      bullet2: "Гибкие MOQ и смешанные контейнеры",
      bullet3: "СТМ на отдельные линии",
      bullet4: "Маркетинговая и POS-поддержка",
      lblFullName: "Ф.И.О. *", lblCompany: "Компания *", lblEmail: "Рабочий email *",
      lblPhone: "Телефон", lblCountry: "Страна / рынок *", lblBrand: "Интересующий бренд",
      lblInquiryType: "Тип запроса", lblMessage: "Расскажите о вашем бизнесе *",
      phFullName: "Иван Иванов", phCompany: "ООО «Глобал Бевериджиз»", phEmail: "ivan@company.ru",
      phPhone: "+7 495 000 00 00", phCountry: "Россия", phBrandAny: "Все / любой",
      phMessage: "Ожидаемые объёмы, текущий портфель, каналы продаж…",
      typeDistribution: "Дистрибуция / Импорт", typeHoreca: "HoReCa",
      typePrivate: "СТМ / Контрактное производство", typeRetail: "Розница", typeOther: "Другое",
      submit: "Отправить запрос", sending: "Отправка…",
      privacy: "Отправляя, вы соглашаетесь на связь от Hupla по вашему запросу. Мы не передаём ваши данные.",
      successTitle: "Запрос получен.",
      successBody: "Спасибо. Наша команда ответит в течение 2 рабочих дней.",
      errorFallback: "Что-то пошло не так. Попробуйте снова.",
      portfolioOverline: "Возьмите с собой",
      portfolioTitle: "Портфолио брендов Hupla 2026.",
      portfolioBody: "13 страниц спецификаций, позиционирования и ключевых кадров каждого бренда — Buzzer, Mamm, Multimalt, Cafeo, Aperina, White Elephant и Desser.",
      portfolioBullet1: "Реальные форматы, размеры и MOQ",
      portfolioBullet2: "Позиционирование, целевой потребитель и канал",
      portfolioBullet3: "Утверждённые продуктовые фото для презентаций",
      portfolioHint: "Получите PDF, готовый к печати ↓",
      portfolioReady: "Ваше портфолио брендов 2026 готово.",
      portfolioDownload: "Скачать PDF (2,9 МБ)",
    },
    contact: {
      overline: "Контакты", titleA: "Скажите привет,", titleCity: "Стамбул", titleB: "слушает.",
      subtitle: "Наш головной офис в Шишли, Стамбул — сердце Hupla. Пишите по партнёрствам, СМИ, вакансиям или просто поздороваться.",
      headquarters: "Головной офис", office: "Офис", mobile: "Мобильный", email: "Email",
    },
    footer: {
      overline: "Hupla", titleJoy: "Радость", titleRest: "хорошей жизни.",
      desc: "Турецкий производитель премиальных напитков и продуктов, создающий собственные бренды для Турции и экспортных рынков с 1998 года.",
      navigate: "Навигация", ourBrands: "Наши бренды",
      linkHome: "Главная", linkAbout: "О нас", linkBrands: "Бренды",
      linkSustainability: "Экоответственность", linkB2B: "B2B-запрос", linkContact: "Контакты",
      groupCompany: "Входит в группу",
      groupTagline: "Швейцарский инвестиционный холдинг из Цуга — наш долгосрочный акционер.",
      headOffice: "Головной офис",
      copyright: "Все права защищены.",
      crafted: "С заботой создано в Стамбуле, Турция.",
    },
    brandPage: {
      backHome: "К брендам", partnerCta: "Стать партнёром",
      whatMakes: "Что делает его особенным", closerLook: "Ближе к",
      availableIn: "Доступно в", productLine: "Продуктовая линейка",
      sideBySide: "Все {name} рядом.",
      skus: "SKU", fromDeck: "Из презентации {name}",
      pages: "стр.", exploreOther: "Другие бренды",
    },
    shows: {
      kicker: "Выставки 2026",
      title: "Приходите к нам на стенд.",
      body: "Забронируйте встречу заранее, чтобы получить приватный слот дегустации с нашей экспортной командой. Наборы образцов ездят с нами на каждую выставку.",
      book: "Записаться на встречу",
      showcasing: "Представленные бренды",
    },
    dist: {
      portalOverline: "Портал дистрибьютора",
      signInTitle: "Войти.",
      emailPh: "E-mail",
      passwordPh: "Пароль",
      signInBtn: "Войти",
      signingIn: "Вход…",
      newDist: "Новый дистрибьютор?",
      registerLink: "Зарегистрироваться →",
      useAdminLogin: "Пожалуйста, используйте вход администратора.",
      loginFailed: "Ошибка входа",
      registerTitle: "Станьте партнёром Hupla.",
      registerSub: "Расскажите нам, кто вы и какую территорию покрываете — портал откроется мгновенно.",
      phName: "Имя и фамилия *",
      phCompany: "Компания *",
      phEmail: "Рабочий e-mail *",
      phPassword: "Пароль (мин. 8 симв.) *",
      territoryLabel: "Территория",
      phArea: "Регион *",
      phCity: "Город *",
      phCountry: "Страна *",
      createBtn: "Создать аккаунт",
      creating: "Создание аккаунта…",
      alreadyRegistered: "Уже зарегистрированы?",
      signInLink: "Войти →",
      welcomeToast: "Добро пожаловать в Hupla — ваш аккаунт активен.",
      regFailed: "Ошибка регистрации",
      welcome: "Добро пожаловать, {name}.",
      signOut: "Выйти",
      yourTerritory: "Ваша территория",
      colCompany: "Компания",
      colArea: "Регион",
      colCity: "Город",
      colCountry: "Страна",
      partnerResources: "Ресурсы для партнёров",
      res1Title: "Портфолио брендов 2026",
      res1Body: "Полный презентационный дек в 300 dpi — все семь брендов со спецификациями и размерами кейсов.",
      res1Action: "Скачать PDF",
      res2Title: "Заказать физические образцы",
      res2Body: "Закажите ящики образцов на ваш склад — доставку для аккредитованных дистрибьюторов берём на себя.",
      res2Action: "Заказать образцы",
      res3Title: "Встретимся на выставках",
      res3Body: "Gulfood · Anuga · SIAL Paris 2026. Забронируйте приватный слот дегустации с нашей экспортной командой.",
      res3Action: "Записаться на встречу",
      helpMail: "Нужна помощь? Пишите на export@hupla.world",
    },
    ageGate: {
      overline: "Проверка возраста",
      title: "Вам должно быть 18 лет или больше.",
      body: "Этот раздел содержит контент об алкогольных напитках. Пожалуйста, подтвердите, что вы достигли возраста употребления алкоголя в вашей стране.",
      yes: "Мне 18 или больше",
      no: "Мне меньше 18",
      rejectedBody: "Извините — для просмотра этого контента вам должно быть 18 лет или больше.",
      goHome: "На главную",
      footer: "Пейте ответственно. Не передавайте лицам, не достигшим совершеннолетия.",
    },
    we: {
      moreCocktails: {
        overline: "Продолжение бара",
        title: "Ещё шесть коктейлей с White Elephant.",
        yuzuSour: {
          pairing: "Yuzu · водка",
          name: "Yuzu Sour",
          recipe: "45 мл водки · 15 мл лимона · долейте Yuzu Tonic · пена яичного белка · цедра юдзу.",
        },
        goldenHighball: {
          pairing: "Yuzu · японский виски",
          name: "Golden Highball",
          recipe: "45 мл японского виски · крупный лёд · долейте Yuzu Tonic · долька лимона.",
        },
        pinkPaloma: {
          pairing: "Barbados · бланко-текила",
          name: "Pink Paloma",
          recipe: "45 мл бланко-текилы · щепотка соли · долейте Barbados Breeze · долька грейпфрута.",
        },
        caribbeanSpritz: {
          pairing: "Barbados · выдержанный ром + просекко",
          name: "Caribbean Spritz",
          recipe: "30 мл выдержанного рома · 60 мл просекко · долейте Barbados Breeze · цедра апельсина.",
        },
        sicilianGT: {
          pairing: "Bitter Lemon · средиземноморский джин",
          name: "Sicilian G&T",
          recipe: "45 мл средиземноморского джина · веточка розмарина · долейте Bitter Lemon · кружок лимона.",
        },
        vodkaBitter: {
          pairing: "Bitter Lemon · водка",
          name: "Cucumber Bitter",
          recipe: "45 мл водки · 3 полоски огурца · долейте Bitter Lemon · веточка мяты.",
        },
      },
    },
    sample: {
      kicker: "Запрос образцов",
      title: "Попробуйте до того, как включите в ассортимент.",
      sub: "Скажите, куда доставить и какие бренды включить — доставку для серьёзных партнёров мы берём на себя.",
      phName: "Имя и фамилия *",
      phCompany: "Компания *",
      phEmail: "Рабочий e-mail *",
      phPhone: "Телефон",
      phCountry: "Страна / рынок *",
      phAddress: "Адрес доставки *",
      brandsLabel: "Бренды для включения *",
      phNotes: "Комментарий (необязательно)",
      submit: "Заказать образцы",
      sending: "Отправка…",
      thanks: "Образцы уже в пути.",
      thanksBody: "Наша экспортная команда подтвердит адрес доставки в течение 2 рабочих дней и сразу же отгрузит образцы.",
      close: "Закрыть",
      errNoBrand: "Пожалуйста, выберите хотя бы один бренд",
      errServer: "Что-то пошло не так. Попробуйте ещё раз.",
      success: "Запрос образцов принят — мы свяжемся с вами.",
    },
  },

  zh: {
    brandContent: {
      mamm: {
        category: "儿童果汁",
        tagline: "捕捉自然的本真——纯粹、平衡、真诚",
        story: "Mamm 把补水变成一场游戏。四位俏皮的动物角色——猴子 Kika、大象 Bogo、小狗 Bambam 和小鸭 Vak——盛载着含维生素 A 与 C 的 100% 混合果汁。带玩具的健康果汁。",
        highlights: [
          "100% 混合果汁（苹果、草莓、李子）",
          "强化维生素 C 和维生素 A",
          "无添加糖、无防腐剂、无人工色素",
          "孩子们喜爱的动物造型收藏瓶",
        ],
        variants: [
          "Kika — 猴子瓶",
          "Bogo — 大象瓶",
          "Bambam — 小狗瓶",
          "Vak — 小鸭瓶",
        ],
        heroSub: "四位俏皮角色。一款健康果汁。",
        attr1: "100% 果汁",
        attr2: "维生素 A + C",
        attr3: "无添加糖",
        skuCount: "4 位角色",
        skuFormat: "角色瓶",
        skuUse: "可收藏",
        family: {
          overline: "认识这一家",
          title: "四位朋友。一款健康果汁。",
          kika: { name: "Kika", animal: "小猴", body: "俏皮、好奇，总是准备好开启冒险。Kika 带来突出的草莓清亮。" },
          bogo: { name: "Bogo", animal: "小象", body: "心胸宽阔、温柔，是团队里最沉着的一员。Bogo 承载李子与苹果的醇厚。" },
          bambam: { name: "Bambam", animal: "小狗", body: "忠实、爱玩，永远准备好再来一轮。Bambam 带来新鲜的苹果-草莓提振。" },
          vak: { name: "Vak", animal: "小鸭", body: "水花四溅、阳光满满，还带点俏皮。Vak 是瓶中的混合果汁派对。" },
        },
      },
      buzzer: {
        category: "能量饮料",
        tagline: "巅峰表现——极致专注与释放的效率",
        story: "Buzzer 让你火力全开。瓜拉那缓慢而稳定地释放咖啡因；B 族维生素让心情保持愉悦。不会突然崩溃——只有更持久、更纯净的能量。想要功能加成？Buzzer Extra 5G 融合真实果汁、氨基酸、L-茶氨酸、镁和维生素 C——货架上营养考量最周到的能量饮品之一。",
        highlights: [
          "瓜拉那 + 优质咖啡因——纯净、持续的提振",
          "提升警觉、专注、记忆与耐力",
          "土耳其人喜爱 25 年的能量饮料",
          "Buzzer Extra 5G：100% 苹果 & 桑葚汁 + 氨基酸、L-茶氨酸、B 族与维生素 C",
        ],
        variants: [
          "Buzzer — 1 升 PET 瓶",
          "Buzzer — 500 毫升罐",
          "Buzzer — 250 毫升罐",
          "Buzzer Extra 5G — 150 毫升 · 苹果 & 桑葚",
        ],
      },
      multimalt: {
        category: "麦芽饮料",
        tagline: "健康妙药——提升幸福感荷尔蒙",
        story: "酿造的大麦麦芽与真实的苹果和芒果汁融合，再以哺乳期妈妈长期信赖的传统草本收尾。Multimalt Date 将麦芽与椰枣及完整 B 族维生素相配。植物基滋养，尽在一罐。",
        highlights: [
          "100% 大麦麦芽 + 真实果汁",
          "草本：茴香、葫芦巴、山羊豆、圣蓟",
          "B1、B2、B3、B5、B6、生物素、叶酸、B12",
          "无防腐剂、无色素、无添加糖",
        ],
        variants: [
          "麦芽 · 芒果 · 苹果 · 植物萃取",
          "椰枣 — 麦芽 & 椰枣汁 · B 族复合",
        ],
        heroSub: "大麦麦芽 + 真实水果 + 草本 — 罐装。",
        attr1: "无添加糖",
        attr2: "无防腐剂",
        attr3: "8 种 B 族维生素",
        skuCount: "2 款灵丹",
        skuFormat: "250 毫升罐装",
        skuUse: "水果 + 麦芽",
        elixirs: {
          overline: "两款灵丹",
          title: "两种配方。一个自然滋养的传统。",
          mango: {
            name: "明亮之灵丹。",
            flavour: "芒果 · 苹果 · 麦芽 · 草本",
            tag: "日常滋养",
            body: "大麦麦芽与真实苹果、芒果汁交融，佐以茴香、葫芦巴、山羊芸香与蓟——百年来受哺乳期妈妈信赖的草本。",
            highlights: [
              "100% 大麦麦芽 + 真实果汁",
              "草本：茴香、葫芦巴、山羊芸香、蓟",
              "无防腐剂 · 无色素 · 无添加糖",
            ],
          },
          date: {
            name: "丰盛之灵丹。",
            flavour: "椰枣 · 麦芽 · 完整 B 族复合",
            tag: "恢复与温暖",
            body: "大麦麦芽与椰枣汁携手——天然富含铁、钾与镁。以完整 B 族复合强化（B1、B2、B3、B5、B6、生物素、叶酸、B12）。",
            highlights: [
              "麦芽 + 椰枣汁 — 天然铁与钾",
              "含叶酸在内的 8 种必需 B 族维生素",
              "无防腐剂 · 无色素 · 无添加糖",
            ],
          },
        },
        lifestyle: {
          caption: "百年来哺乳期妈妈信赖之选。",
          title: "为新手妈妈准备的自然滋养。",
          body: "Multimalt 的力量来自母亲健康领域最受信赖的两种成分——酿造的大麦麦芽与滋养的椰枣——为母亲最需要支持的产后初期而选。",
          benefits: [
            { heading: "大麦麦芽", text: "经久信赖的催乳良伴。大麦麦芽天然富含 β-葡聚糖，与催乳素释放相关——催乳素是维持健康乳汁分泌的关键激素。它还提供缓释复合碳水化合物、铁与 B 族维生素，一小时一小时地为哺乳妈妈补充体力。" },
            { heading: "椰枣", text: "为产后恢复而生的高营养超级水果。椰枣富含天然铁、钾、镁与膳食纤维——产后最需要的营养。它温和的天然糖分带来干净、持久的能量提升，无需额外添加糖；同时纤维支持产后阶段的消化健康。" },
          ],
        },
      },
      cafeo: {
        category: "冰咖啡",
        tagline: "让时光变慢——亲密、温暖而柔和",
        story: "Cafeo 是以咖啡师标准冲煮的 100% 阿拉比卡咖啡，随后冷藏装罐。三种享用方式：丝滑的黑巧克力松露、温暖如焦糖的 Dulce de Leche，以及提神的 Dark Americano。绝不走捷径。",
        highlights: [
          "100% 阿拉比卡 — 冲煮，非速溶粉",
          "无糖 · 无麸质 · 无乳糖",
          "三种心情，三种罐装",
          "即饮，冷藏",
        ],
        variants: ["Dark Chocolate Truffle", "Dulce de Leche", "Dark Americano"],
        heroSub: "冲煮、冷藏、装罐。三种心情。",
        attr1: "100% 阿拉比卡",
        attr2: "无糖",
        attr3: "即饮",
        skuCount: "3 种心情",
        skuFormat: "250 毫升罐装",
        skuUse: "冷藏",
        moods: {
          overline: "三种心情",
          title: "三种罐装。三种让时光放慢的方式。",
          darkChoc: {
            name: "黑巧与松露。",
            flavour: "Dark Chocolate Truffle",
            body: "70% 可可与慢煮阿拉比卡相遇。介于会议与归家之间的最佳啜饮。",
          },
          dulce: {
            name: "温暖的那一款。",
            flavour: "Dulce de Leche",
            body: "焦糖化牛奶覆于冷萃浓缩之上。几乎是一份甜点。几乎。",
          },
          americano: {
            name: "直击的一击。",
            flavour: "Dark Americano",
            body: "无糖，无奶。只有冲煮阿拉比卡，冷藏装罐。开启新一天最清澈的方式。",
          },
        },
        moment: {
          overline: "从豆到罐",
          title: "慢慢冲煮，从不匆忙。",
          body: "100% 阿拉比卡咖啡豆，以咖啡师之法冲煮 — 然后冷藏装罐，让仪式感留存。石板之上，三种心情：丝滑的 Dark Chocolate Truffle、温暖的 Dulce de Leche、提神的 Dark Americano。",
          tag: "Cafeo · 冲煮冰咖啡",
        },
      },
      aperina: {
        category: "开胃混合饮",
        tagline: "无与伦比的原创之味",
        story: "Aperina 是我们的即调鸡尾酒基酒——原创风味、独特色泽，为调酒师无需思考的那一刻而生。加冰倒入，苏打水注满，杯口一片橙皮。夕阳时分，一切就绪。",
        highlights: [
          "即调的气泡鸡尾酒基酒",
          "标志性苦甜苦橙灵魂",
          "无可替代的色泽与风味",
          "调酒师的轻松倾倒",
        ],
        variants: ["1 升 PET 瓶 — 原创配方"],
        heroSub: "单一配方开胃酒，即倒即饮。",
        skuVolume: "1 升",
        skuFormat: "PET 瓶",
        skuRecipe: "原创配方",
        momentTitle: "黄金时刻的仪式。",
        steps: [
          "在葡萄酒杯中加满冰块",
          "倒入 Aperina，加入苏打水与偏好的烈酒",
          "以一片橙子作点缀",
        ],
        momentCaption: "— Aperina 原创配方。加冰、苏打水与橙片饮用。",
      },
      "white-elephant": {
        category: "高端调酒饮",
        tagline: "定义精致——一抹优雅与匠心",
        story: "为专业酒吧而生。来自 FeverTree 树皮的天然奎宁、Bitter Lemon 中的真实柠檬汁，以及两款高端汤力——Japanese Yuzu 呈现柑橘细腻，Barbados Breeze 带来温暖热带感。",
        highlights: [
          "含天然奎宁的手工汤力",
          "来自 FeverTree 树皮，含奎宁高达 85 毫克",
          "低卡路里 · 餐厅与酒吧级",
          "1 升 PET 瓶 — 吧台就绪格式",
        ],
        variants: [
          "高端汤力 — Japanese Yuzu",
          "高端汤力 — Barbados Breeze",
          "Bitter Lemon",
        ],
        heroSub: "手工调酒饮，专为严肃酒吧而生。",
        attr1: "天然奎宁",
        attr2: "低卡路里",
        attr3: "吧台级别",
        skuVolume: "1 升",
        skuFormat: "PET 瓶",
        skuRange: "3 款配方",
        triptych: {
          overline: "三款汤力，三种瞬间",
          title: "调酒师的精选清单。",
          yuzu: {
            name: "Japanese Yuzu 汤力",
            pairing: "最佳搭配金酒",
            steps: [
              "高球杯中加满冰块",
              "倒入 45 毫升金酒，加满 Yuzu 汤力",
              "以紫苏叶或柠檬皮点缀",
            ],
          },
          barbados: {
            name: "Barbados Breeze 汤力",
            pairing: "最佳搭配陈年白朗姆酒",
            steps: [
              "Copa 杯中加满碎冰",
              "倒入 45 毫升陈年白朗姆酒，加满 Barbados Breeze",
              "以粉红葡萄柚皮完美收尾",
            ],
          },
          bitter: {
            name: "Bitter Lemon",
            pairing: "最佳搭配金酒或伏特加",
            steps: [
              "高球杯中加满冰块",
              "倒入 45 毫升金酒或伏特加，加满 Bitter Lemon",
              "以柠檬皮和薄荷枝点缀",
            ],
          },
        },
        moments: {
          overline: "White Elephant 瞬间",
          title: "精致与倾倒相遇之地。",
          bitter: {
            title: "明亮的锋芒。",
            body: "Bitter Lemon 置身地中海柑橘之间——真实柠檬汁、天然奎宁，以及提升高球杯或金汤力的那一抹清脆锋芒。",
            tag: "Bitter Lemon",
          },
          tonics: {
            title: "高端倾倒。",
            body: "Japanese Yuzu 呈现柑橘细腻，Barbados Breeze 带来热带温暖。两款汤力，同一份吧台级匠心——加冰、佐迷迭香倾倒而出。",
            tag: "Japanese Yuzu · Barbados Breeze",
          },
        },
      },
      desser: {
        category: "酱汁与糖浆",
        tagline: "创意的化身——打破所有甜蜜的规则",
        story: "Desser 是最后一笔——六种为咖啡师、调酒师与糕点师量身打造的风味。从 De Mer Whisper（海盐焦糖）到 Belgravia Celestial（白巧克力、开心果、香蕉）。",
        highlights: [
          "主厨级酱汁与糖浆",
          "果香 · 坚果 · 深沉 · 异域风味走向",
          "饱满口感，丰润余味",
          "创新瓶身 + 泵浦系统",
        ],
        variants: [
          "De Mer Whisper — 海盐焦糖",
          "Madagascar Charm — 香草 · 覆盆子",
          "Peruvian Noir — 黑巧克力松露",
          "Ivory Pearl — 白巧克力 · 澳洲坚果",
          "Belgravia Celestial — 白巧克力 · 开心果 · 香蕉",
          "Silken Mist — Dulce de Leche · 杏仁",
        ],
        heroSub: "六款签名。天堂匠造。",
        attr1: "主厨级别",
        attr2: "饱满口感",
        attr3: "泵浦系统",
        skuCount: "6 款配方",
        skuFormat: "PET 瓶",
        skuUse: "咖啡 · 鸡尾酒 · 甜点",
        signatures: {
          overline: "六大签名",
          title: "六种风味。六个可谱写的瞬间。",
          deMer: {
            name: "De Mer Whisper",
            flavour: "海盐焦糖",
            body: "低温慢煮的太妃糖上，海盐低语。倾倒于威士忌酸酒或浓郁的 flat white 之上。",
          },
          madagascar: {
            name: "Madagascar Charm",
            flavour: "香草 · 覆盆子",
            body: "波旁香草与覆盆子的明亮相遇。经典之选，成就 Spritz 与 French 75。",
          },
          peruvian: {
            name: "Peruvian Noir",
            flavour: "黑巧克力松露",
            body: "70% 可可的醇厚，松露般的深度。让摩卡成为一个瞬间，让熔岩巧克力成为回忆。",
          },
          ivory: {
            name: "Ivory Pearl",
            flavour: "白巧克力 · 澳洲坚果",
            body: "丝滑白巧克力与烘焙澳洲坚果的暖意。优雅地流淌于奶酪蛋糕与意式冰淇淋之上。",
          },
          belgravia: {
            name: "Belgravia Celestial",
            flavour: "白巧 · 开心果 · 香蕉",
            body: "本店最戏剧化的组合。开心果与香蕉铺陈于奶油白巧之上 — 为层次甜点而生。",
          },
          silken: {
            name: "Silken Mist",
            flavour: "Dulce de Leche · 杏仁",
            body: "焦糖化牛奶与烘焙杏仁的柔软。拿铁、提拉米苏与慢悠悠午后的签名之选。",
          },
        },
      },
    },
    nav: {
      brands: "品牌", about: "关于", sustainability: "可持续",
      b2b: "B2B", contact: "联系", cta: "成为合作伙伴",
      sample: "索取样品", distributors: "分销商",
    },
    hero: {
      overline: "土耳其饮品与食品品牌制造商",
      the: "美好", tasteOf: "生活", living: "的", well: "滋味。",
      subtitle: "自1998年以来从土耳其走向世界——为在意所饮、所食、所分享的人们打造的品牌家族。",
      exploreBrands: "浏览我们的品牌", talkTrade: "洽谈合作",
    },
    about: {
      title: "关于我们",
      body1: "源于一个简单而有力的信念：食品与饮品不仅仅是产品——它们是连接人们的体验。",
      body2: "从一开始，我们的目标就是打造一个全球风味共同体；将品质、好奇心与情感融入日常生活的每一刻。今天，在 Hupla 的旗下",
      body3: "组成了一个充满活力的品牌家族——每个都讲述着自己的故事，每个都唤起共同的喜悦。",
    },
    brands: {
      title: "不止于品牌之家",
      subtitle: "每一个品牌都映射着不同的生活节奏",
      portfolio: "产品组合", of: "/", dragSwipe: "拖动 / 滑动",
      exploreBrand: "查看", ourBrands: "旗下品牌",
      livingCulture: "一种鲜活的文化",
      manifesto1: "每一杯、每一口、每一味都讲述着故事——手艺、收获、家的故事。",
      manifesto2: "从伊斯坦布尔到利雅得，从拉各斯到伦敦——Hupla 是共享的美好生活的喜悦。",
      cities: "从伊斯坦布尔到利雅得，从拉各斯到伦敦。",
    },
    sustainability: {
      title: "可持续发展",
      quote: "对我们而言，可持续不是目标——而是一种生活方式。",
      body: "Hupla 生产的每一步——从原料采购到包装——都以责任为导向。减糖、植物基配方、可回收包装和诚实的标签，不是附加项——这是我们的底线。",
    },
    group: {
      kicker: "隶属集团",
      title: "由一家瑞士投资控股公司支持。",
      body: "Hupla 是 De Almeda Seligmann Capital AG 投资组合中的饮品与食品生产公司——这家总部位于楚格的瑞士投资控股集团，以长期、跨代际的视野管理其土耳其饮品品牌。凭借瑞士治理与土耳其匠心，持续推进其全球范围内的雄心投资与增长。",
      cta: "dealmedaseligmann.ch",
      pillars: {
        swiss: { title: "瑞士治理", body: "楚格注册，遵循机构级透明度与报告标准。" },
        long:  { title: "长期经营者", body: "以世代思考的耐心资本，而非季度——这才是饮品品牌应有的建设方式。" },
        global:{ title: "全球布局", body: "生产扎根于土耳其，分销雄心遍及欧洲、中东及非洲乃至更远。" },
      },
    },
    b2b: {
      overline: "B2B 咨询",
      titleA: "把 Hupla", titleB: "带到你的", titleC: "市场", titleDot: "。",
      subtitle: "经销商、进口商、连锁客户与餐饮运营商——告诉我们您在哪里，希望上架哪些品牌。我们的出口团队会在两个工作日内回复正式咨询。",
      bullet1: "完整品牌组合 + 规格包",
      bullet2: "灵活起订量 & 集装箱混装",
      bullet3: "部分品项可做自有品牌",
      bullet4: "市场营销与终端支持",
      lblFullName: "姓名 *", lblCompany: "公司 *", lblEmail: "商务邮箱 *",
      lblPhone: "电话", lblCountry: "国家 / 市场 *", lblBrand: "感兴趣的品牌",
      lblInquiryType: "咨询类型", lblMessage: "介绍您的业务 *",
      phFullName: "张伟", phCompany: "环球饮品有限公司", phEmail: "zhang@company.cn",
      phPhone: "+86 138 0000 0000", phCountry: "中国", phBrandAny: "任意 / 全部",
      phMessage: "预期销量、现有产品组合、目标渠道……",
      typeDistribution: "经销 / 进口", typeHoreca: "餐饮/酒店",
      typePrivate: "自有品牌 / 代工", typeRetail: "零售 / 现代渠道", typeOther: "其他",
      submit: "提交咨询", sending: "发送中…",
      privacy: "提交即表示您同意 Hupla 就您的咨询与您联系。我们不会分享您的数据。",
      successTitle: "已收到咨询。",
      successBody: "感谢您。我们的出口团队将在两个工作日内回复。",
      errorFallback: "出现问题，请重试。",
      portfolioOverline: "随身携带",
      portfolioTitle: "2026 Hupla 品牌手册。",
      portfolioBody: "覆盖每个品牌的 13 页产品规格、定位说明与主视觉 — Buzzer、Mamm、Multimalt、Cafeo、Aperina、White Elephant 与 Desser。",
      portfolioBullet1: "真实包装规格、格式与 MOQ",
      portfolioBullet2: "定位、目标消费者与渠道匹配",
      portfolioBullet3: "已授权的产品摄影，可直接用于路演",
      portfolioHint: "获取可直接打印的 PDF ↓",
      portfolioReady: "您的 2026 品牌手册已就绪。",
      portfolioDownload: "下载 PDF（2.9 MB）",
    },
    contact: {
      overline: "联系", titleA: "打声招呼，", titleCity: "伊斯坦布尔", titleB: "在听。",
      subtitle: "位于伊斯坦布尔希什利的总部是 Hupla 的神经中枢。合作、媒体、招聘或简单地问声好，都欢迎联络。",
      headquarters: "总部", office: "办公室", mobile: "手机", email: "邮箱",
    },
    footer: {
      overline: "Hupla", titleJoy: "美好生活", titleRest: "的喜悦。",
      desc: "土耳其高端饮品与食品制造商，自1998年起以自有品牌家族服务于土耳其及出口市场。",
      navigate: "导航", ourBrands: "旗下品牌",
      linkHome: "首页", linkAbout: "关于", linkBrands: "品牌",
      linkSustainability: "可持续", linkB2B: "B2B 咨询", linkContact: "联系",
      groupCompany: "所属集团",
      groupTagline: "总部位于楚格的瑞士投资控股集团 — 我们的长期母公司。",
      headOffice: "总部地址",
      copyright: "版权所有。",
      crafted: "于伊斯坦布尔精心制造。",
    },
    brandPage: {
      backHome: "返回品牌", partnerCta: "成为合作伙伴",
      whatMakes: "特别之处", closerLook: "深入了解",
      availableIn: "可选规格", productLine: "产品系列",
      sideBySide: "所有 {name} 一览。",
      skus: "款", fromDeck: "来自 {name} 展示",
      pages: "页", exploreOther: "查看其他品牌",
    },
    shows: {
      kicker: "2026 年国际展会",
      title: "展会现场与我们见面。",
      body: "请提前预约与出口团队的私人品鉴时段。我们的样品套装随行至每一场展会。",
      book: "预约会面",
      showcasing: "展出品牌",
    },
    dist: {
      portalOverline: "分销商门户",
      signInTitle: "登录。",
      emailPh: "电子邮箱",
      passwordPh: "密码",
      signInBtn: "登录",
      signingIn: "登录中…",
      newDist: "新分销商？",
      registerLink: "注册 →",
      useAdminLogin: "请使用管理员登录。",
      loginFailed: "登录失败",
      registerTitle: "成为 Hupla 合作伙伴。",
      registerSub: "告诉我们您是谁以及您所覆盖的区域 — 我们将立即开通您的门户。",
      phName: "姓名 *",
      phCompany: "公司 *",
      phEmail: "工作邮箱 *",
      phPassword: "密码（至少 8 位）*",
      territoryLabel: "区域",
      phArea: "地区 / 区域 *",
      phCity: "城市 *",
      phCountry: "国家 *",
      createBtn: "创建账户",
      creating: "创建账户中…",
      alreadyRegistered: "已经注册？",
      signInLink: "登录 →",
      welcomeToast: "欢迎加入 Hupla — 您的分销商账户已生效。",
      regFailed: "注册失败",
      welcome: "欢迎，{name}。",
      signOut: "退出登录",
      yourTerritory: "您的区域",
      colCompany: "公司",
      colArea: "地区",
      colCity: "城市",
      colCountry: "国家",
      partnerResources: "合作伙伴资源",
      res1Title: "2026 品牌画册",
      res1Body: "完整的 300 dpi 演示文档 — 七大品牌全部产品规格与整箱尺寸。",
      res1Action: "下载 PDF",
      res2Title: "申请实物样品",
      res2Body: "订购发往您仓库的样品箱 — 已入网的分销商由我们承担运费。",
      res2Action: "申请样品",
      res3Title: "展会与我们见面",
      res3Body: "Gulfood · Anuga · SIAL Paris 2026。预约与出口团队的私人品鉴时段。",
      res3Action: "预约会面",
      helpMail: "需要帮助？请联系 export@hupla.world",
    },
    ageGate: {
      overline: "年龄验证",
      title: "您须年满 18 岁方可进入。",
      body: "此部分含酒精饮品内容。请确认您已达到您所在国家的合法饮酒年龄。",
      yes: "我已年满 18 岁",
      no: "我未满 18 岁",
      rejectedBody: "抱歉——您须年满 18 岁才能查看此内容。",
      goHome: "返回首页",
      footer: "请理性饮酒。切勿分享给未达合法饮酒年龄者。",
    },
    we: {
      moreCocktails: {
        overline: "吧台更多灵感",
        title: "White Elephant 六款经典再演绎。",
        yuzuSour: {
          pairing: "Yuzu · 伏特加",
          name: "Yuzu Sour",
          recipe: "45 毫升伏特加 · 15 毫升柠檬 · 加入 Yuzu Tonic · 蛋白泡沫 · 柚子皮。",
        },
        goldenHighball: {
          pairing: "Yuzu · 日本威士忌",
          name: "Golden Highball",
          recipe: "45 毫升日本威士忌 · 大冰块 · 加入 Yuzu Tonic · 柠檬片。",
        },
        pinkPaloma: {
          pairing: "Barbados · 白龙舌兰",
          name: "Pink Paloma",
          recipe: "45 毫升白龙舌兰 · 一撮盐 · 加入 Barbados Breeze · 西柚角。",
        },
        caribbeanSpritz: {
          pairing: "Barbados · 陈年朗姆 + 普罗塞克",
          name: "Caribbean Spritz",
          recipe: "30 毫升陈年朗姆 · 60 毫升普罗塞克 · 加入 Barbados Breeze · 橙皮。",
        },
        sicilianGT: {
          pairing: "Bitter Lemon · 地中海金酒",
          name: "Sicilian G&T",
          recipe: "45 毫升地中海金酒 · 迷迭香枝 · 加入 Bitter Lemon · 柠檬圈。",
        },
        vodkaBitter: {
          pairing: "Bitter Lemon · 伏特加",
          name: "Cucumber Bitter",
          recipe: "45 毫升伏特加 · 3 片黄瓜 · 加入 Bitter Lemon · 薄荷枝。",
        },
      },
    },
    sample: {
      kicker: "样品申请",
      title: "上架前先试样。",
      sub: "告诉我们发往何处以及包含哪些品牌 — 对认真的客户我们承担运费。",
      phName: "姓名 *",
      phCompany: "公司 *",
      phEmail: "工作邮箱 *",
      phPhone: "电话",
      phCountry: "国家 / 市场 *",
      phAddress: "收货地址 *",
      brandsLabel: "包含品牌 *",
      phNotes: "备注（选填）",
      submit: "申请样品",
      sending: "发送中…",
      thanks: "样品已上路。",
      thanksBody: "我们的出口团队将在 2 个工作日内确认您的收货地址，并立即发运样品。",
      close: "关闭",
      errNoBrand: "请至少选择一个品牌",
      errServer: "出了点问题。请再试一次。",
      success: "已收到样品申请 — 我们会与您联系。",
    },
  },

  ar: {
    brandContent: {
      mamm: {
        category: "عصير فاكهة للأطفال",
        tagline: "يلتقط جوهر الطبيعة — نقيّ، متوازن، صادق",
        story: "يحوّل Mamm الترطيب إلى لعبة. أربع شخصيات حيوانية مرحة — القرد Kika والفيل Bogo والكلب Bambam والبطة Vak — تحمل عصير فواكه مختلطاً بنسبة 100% مع فيتاميني A و C. عصير صحّي مع لعبة أعلاه.",
        highlights: [
          "100% عصير فواكه مختلطة (تفاح، فراولة، برقوق)",
          "مدعّم بفيتامين C وفيتامين A",
          "بدون سكر مضاف، بدون مواد حافظة، بدون ألوان صناعية",
          "زجاجات شخصيات حيوانية للجمع يعشقها الأطفال",
        ],
        variants: [
          "Kika — زجاجة القرد",
          "Bogo — زجاجة الفيل",
          "Bambam — زجاجة الكلب",
          "Vak — زجاجة البطة",
        ],
        heroSub: "أربع شخصيات مرحة. عصير صحّي واحد.",
        attr1: "100% عصير فواكه",
        attr2: "فيتامين A + C",
        attr3: "بدون سكر مضاف",
        skuCount: "4 شخصيات",
        skuFormat: "زجاجة شخصية",
        skuUse: "قابلة للجمع",
        family: {
          overline: "تعرّف على العائلة",
          title: "أربعة أصدقاء. عصير صحّي واحد.",
          kika: { name: "Kika", animal: "القرد", body: "مرحة، فضولية، دوماً في مزاج المغامرة. تجلب Kika إشراقة الفراولة الأمامية." },
          bogo: { name: "Bogo", animal: "الفيل", body: "كبير القلب، لطيف، وأكثر أفراد الطاقم هدوءاً. يحمل Bogo عمق الخوخ والتفاح." },
          bambam: { name: "Bambam", animal: "الكلب", body: "وفيّ، مرح، ودائماً جاهز لجولة جديدة. يقدّم Bambam ارتفاعة تفاح-فراولة منعشة." },
          vak: { name: "Vak", animal: "البطة", body: "رذاذية، مُشرقة، وقليلاً من المرح. Vak هي حفلة الفواكه المختلطة في زجاجة." },
        },
      },
      buzzer: {
        category: "مشروب طاقة",
        tagline: "أداء استثنائي — تركيز حاد وإنتاجية منطلقة",
        story: "يساعدك Buzzer على العمل بكامل قدرتك. يُطلق الغوارانا الكافيين ببطء وثبات، وتحافظ فيتامينات B على المزاج. بلا هبوط مفاجئ — بل احتراق أطول وأنقى. للمسة وظيفية، يجمع Buzzer Extra 5G بين عصير الفاكهة الحقيقي والأحماض الأمينية و L-ثيانين والمغنيسيوم وفيتامين C — على الأرجح أكثر علبة طاقة مدروسة تغذوياً على الرف.",
        highlights: [
          "غوارانا + كافيين عالي الجودة — دفعة نقية ومستمرة",
          "زيادة اليقظة والتركيز والذاكرة والقدرة على التحمّل",
          "مشروب الطاقة الأكثر حباً في تركيا منذ 25 عاماً",
          "Buzzer Extra 5G: 100% عصير تفاح وتوت أسود + أحماض أمينية و L-ثيانين ومجموعة B وفيتامين C",
        ],
        variants: [
          "Buzzer — زجاجة PET سعة 1 لتر",
          "Buzzer — علبة 500 مل",
          "Buzzer — علبة 250 مل",
          "Buzzer Extra 5G — 150 مل · تفاح وتوت أسود",
        ],
      },
      multimalt: {
        category: "مشروب الشعير",
        tagline: "إكسير الصحة — يرفع مستوى هرمونات السعادة",
        story: "يتزوّج شعير الشعير المخمّر بعصير التفاح والمانجو الحقيقي، ثم يُختتم بأعشاب تقليدية موثوقة لدى الأمهات المرضعات. يجمع Multimalt Date بين الشعير والتمر ومجموعة كاملة من فيتامينات B. غذاء نباتي في علبة.",
        highlights: [
          "100% شعير الشعير + عصير فاكهة حقيقي",
          "أعشاب: شمر، حلبة، سذاب الماعز، الشوك المبارك",
          "B1، B2، B3، B5، B6، بيوتين، حمض الفوليك، B12",
          "بدون مواد حافظة أو ملوّنات أو سكر مضاف",
        ],
        variants: [
          "شعير · مانجو · تفاح · مستخلصات نباتية",
          "التمر — شعير & عصير التمر · مجموعة فيتامينات B",
        ],
        heroSub: "شعير الشعير + فاكهة حقيقية + أعشاب — في علبة.",
        attr1: "بدون سكر مضاف",
        attr2: "بدون مواد حافظة",
        attr3: "8 فيتامينات B",
        skuCount: "إكسيران",
        skuFormat: "علبة 250 مل",
        skuUse: "فاكهة + شعير",
        elixirs: {
          overline: "الإكسيران",
          title: "وصفتان. تقليدٌ واحد من التغذية الطبيعية.",
          mango: {
            name: "الإكسير المُشرق.",
            flavour: "مانجو · تفاح · شعير · أعشاب",
            tag: "تغذية يومية",
            body: "شعير الشعير مع عصير التفاح والمانجو الحقيقي، يُختتم بشمر وحلبة وسذاب الماعز والشوك المبارك — أعشاب موثوقة لدى الأمهات المرضعات منذ أكثر من قرن.",
            highlights: [
              "100% شعير الشعير + عصير فاكهة حقيقي",
              "أعشاب: شمر، حلبة، سذاب الماعز، الشوك المبارك",
              "بدون مواد حافظة · بدون ملوّنات · بدون سكر مضاف",
            ],
          },
          date: {
            name: "الإكسير الغنيّ.",
            flavour: "تمر · شعير · مجموعة كاملة من فيتامينات B",
            tag: "تعافٍ ودفء",
            body: "شعير الشعير في زواج مع عصير التمر — غنيّ طبيعيّاً بالحديد والبوتاسيوم والمغنيسيوم. مدعّم بمجموعة كاملة من فيتامينات B (B1، B2، B3، B5، B6، بيوتين، حمض الفوليك، B12).",
            highlights: [
              "شعير + عصير تمر — حديد وبوتاسيوم طبيعيّان",
              "8 فيتامينات B أساسية بما فيها حمض الفوليك",
              "بدون مواد حافظة · بدون ملوّنات · بدون سكر مضاف",
            ],
          },
        },
        lifestyle: {
          caption: "موثوقٌ به من الأمهات المرضعات منذ أكثر من قرن.",
          title: "غذاء الطبيعة للأمهات الجدد.",
          body: "يستمدّ Multimalt قوّته من أكثر مكوّنين موثوقين في العناية بالأمهات — شعير الشعير المخمّر وثمرة التمر الغنيّة — كل منهما اختير لدوره في دعم الأشهر الأولى الشاقّة من الأمومة.",
          benefits: [
            { heading: "شعير الشعير", text: "غذاءٌ مُدرّ للحليب عبر الأزمنة. شعير الشعير غنيّ بالبيتا-غلوكان بشكل طبيعي، وهو مرتبط بإفراز البرولاكتين — الهرمون الذي يساعد على الحفاظ على إمداد صحّي للحليب. كما يوفّر كربوهيدرات معقّدة بطيئة الاحتراق وحديداً وفيتامينات B تُعيد للأم المرضعة نشاطها ساعةً بعد ساعة." },
            { heading: "ثمرة التمر", text: "ثمرة سوبر غنيّة بالمغذّيات للتعافي. التمر مليء بالحديد الطبيعي والبوتاسيوم والمغنيسيوم والألياف — أكثر العناصر التي تحتاجها الأم بعد الولادة. سكرياته الطبيعية اللطيفة تمنح دفعة طاقة نقية ومستدامة دون سكر مضاف، بينما تدعم أليافه الهضم في أسابيع ما بعد الولادة." },
          ],
        },
      },
      cafeo: {
        category: "قهوة مثلجة",
        tagline: "يبطئ الزمن — حميم، دافئ ومريح",
        story: "Cafeo قهوة أرابيكا 100% محضّرة كما يُعدّها الباريستا — ثم تُبرّد وتُعبّأ في علب. ثلاث طرق للتذوّق: Dark Chocolate Truffle الحريرية، Dulce de Leche بدفء الكراميل، و Dark Americano المنعشة. بلا اختصارات.",
        highlights: [
          "100% أرابيكا — محضّرة، لا مسحوق",
          "خالٍ من السكر · خالٍ من الغلوتين · خالٍ من اللاكتوز",
          "ثلاثة أمزجة، ثلاث علب",
          "جاهز للشرب، مبرّد",
        ],
        variants: ["Dark Chocolate Truffle", "Dulce de Leche", "Dark Americano"],
        heroSub: "محضّرة، مبرّدة، معبّأة. ثلاث حالات مزاجية.",
        attr1: "100% أرابيكا",
        attr2: "خالٍ من السكر",
        attr3: "جاهز للشرب",
        skuCount: "3 حالات",
        skuFormat: "علبة 250 مل",
        skuUse: "مبرّد",
        moods: {
          overline: "الحالات الثلاث",
          title: "ثلاث علب. ثلاث طرقٍ لإبطاء الزمن.",
          darkChoc: {
            name: "الداكن والمُتَرْفَل.",
            flavour: "Dark Chocolate Truffle",
            body: "70% كاكاو تلتقي بأرابيكا محضّرة ببطء. تُحتسى بين الاجتماع والمشي إلى البيت.",
          },
          dulce: {
            name: "الدافئ.",
            flavour: "Dulce de Leche",
            body: "حليب مُكرمَل فوق إسبريسو بارد التحضير. تقريباً حلوى. تقريباً.",
          },
          americano: {
            name: "الطلقة المباشرة.",
            flavour: "Dark Americano",
            body: "بلا سكر، بلا حليب. مجرّد أرابيكا محضّرة، مبرّدة ومعبّأة. أوضح طريقة لبدء اليوم.",
          },
        },
        moment: {
          overline: "من الحبّة إلى العلبة",
          title: "محضّرة ببطء. بلا استعجال.",
          body: "حبوب أرابيكا 100%، محضّرة كما يفعل الباريستا — ثم تُبرَّد وتُعبَّأ لتحافظ على الطقس. ثلاث حالات مزاجية على بلاطة حجرية: Dark Chocolate Truffle حريرية، Dulce de Leche دافئة، Dark Americano منعشة.",
          tag: "Cafeo · قهوة مثلجة محضّرة",
        },
      },
      aperina: {
        category: "مزيج فاتح للشهية",
        tagline: "طعم أصيل لا يُضاهى",
        story: "Aperina مزيج كوكتيلاتنا الجاهز للتقديم — نكهات أصلية ولون لا يُخطئ به، صُنع للحظة لا يرغب فيها الساقي بالتفكير. اسكب فوق الثلج، أضف الصودا، شريحة برتقال على الحافة. غروب الشمس، جاهز.",
        highlights: [
          "قاعدة كوكتيل فوّار جاهزة للتقديم",
          "روح البرتقال المرّ ذات المرّ الحلو المميّز",
          "لون ونكهة لا لبس فيهما",
          "صبّة سهلة للساقي",
        ],
        variants: ["زجاجة PET 1 لتر — الوصفة الأصلية"],
        heroSub: "أبيريتيف بوصفة واحدة، جاهز للتقديم.",
        skuVolume: "1 لتر",
        skuFormat: "زجاجة PET",
        skuRecipe: "الوصفة الأصلية",
        momentTitle: "طقس الساعة الذهبية.",
        steps: [
          "املأ كأس النبيذ بالثلج",
          "اسكب أبيرينا، وأكمل بالصودا والمشروب الروحي المفضّل",
          "زيّن بشريحة برتقال",
        ],
        momentCaption: "— أبيرينا، الوصفة الأصلية. تُقدَّم مع الثلج والصودا والبرتقال.",
      },
      "white-elephant": {
        category: "مِكسر فاخر",
        tagline: "يُعرّف الرقيّ — لمسة من الأناقة والحِرفية",
        story: "لِبَارات محترفة. كينين حقيقي من لحاء FeverTree، عصير ليمون حقيقي في Bitter Lemon، وتونيكان فاخران — Japanese Yuzu لرشاقة الحمضيات، و Barbados Breeze لمزيج استوائي أدفأ.",
        highlights: [
          "تونيك مصنوع يدوياً بالكينين الطبيعي",
          "حتى 85 مغ من الكينين من لحاء FeverTree",
          "قليل السعرات · بمعايير المطاعم والبارات",
          "زجاجة PET 1 لتر — تنسيق جاهز للبار",
        ],
        variants: [
          "تونيك فاخر — Japanese Yuzu",
          "تونيك فاخر — Barbados Breeze",
          "Bitter Lemon",
        ],
        heroSub: "مِكسرات مصنوعة يدوياً، لِبارات محترفة.",
        attr1: "كينين طبيعي",
        attr2: "قليل السعرات",
        attr3: "بمعايير البار",
        skuVolume: "1 لتر",
        skuFormat: "زجاجة PET",
        skuRange: "3 وصفات",
        triptych: {
          overline: "ثلاثة تونيكات، ثلاث لحظات",
          title: "قائمة الساقي المختصرة.",
          yuzu: {
            name: "تونيك Japanese Yuzu",
            pairing: "الأفضل مع الجن",
            steps: [
              "املأ كأس Highball بمكعبات الثلج",
              "اسكب 45 مل من الجن وأكمل بتونيك Yuzu",
              "زيّن بورقة شيسو أو قشرة ليمون",
            ],
          },
          barbados: {
            name: "تونيك Barbados Breeze",
            pairing: "الأفضل مع الرم الأبيض المعتّق",
            steps: [
              "املأ كأس Copa بالثلج المجروش",
              "اسكب 45 مل من الرم الأبيض المعتّق وأكمل بـ Barbados Breeze",
              "اختم بقشرة جريب فروت وردي",
            ],
          },
          bitter: {
            name: "Bitter Lemon",
            pairing: "الأفضل مع الجن أو الفودكا",
            steps: [
              "املأ كأس Highball بمكعبات الثلج",
              "اسكب 45 مل من الجن أو الفودكا وأكمل بـ Bitter Lemon",
              "زيّن بقشرة ليمون وفرع نعناع",
            ],
          },
        },
        moments: {
          overline: "لحظات White Elephant",
          title: "حيث يلتقي الرقيّ بالسكب.",
          bitter: {
            title: "الحافّة المُشرقة.",
            body: "Bitter Lemon بين حمضيات المتوسط — عصير ليمون حقيقي، وكينين طبيعي، وتلك الحافّة المنعشة التي ترفع كأس Highball أو Gin & Tonic.",
            tag: "Bitter Lemon",
          },
          tonics: {
            title: "السكب الفاخر.",
            body: "Japanese Yuzu لرشاقة الحمضيات. Barbados Breeze لدفء استوائي. تونيكان بحرفة بار واحدة — يُسكبان مع الثلج وفرع إكليل الجبل.",
            tag: "Japanese Yuzu · Barbados Breeze",
          },
        },
      },
      desser: {
        category: "الصلصات والشرابات",
        tagline: "يجسّد الإبداع — يكسر كل قواعد الحلاوة",
        story: "Desser هو اللمسة الأخيرة — ستّ ملامح نكهة صُممت للباريستا والمكسولوجيين وطهاة الحلويات. من De Mer Whisper (كراميل مملّح) إلى Belgravia Celestial (شوكولاتة بيضاء، فستق، موز).",
        highlights: [
          "صلصات وشرابات بمستوى الشيف",
          "ملامح فاكهية · بندقية · عميقة · غرائبية",
          "قوام دَسِم وإحساس فَمَوي غنيّ",
          "زجاجة مبتكرة + نظام مضخّة",
        ],
        variants: [
          "De Mer Whisper — كراميل مملّح",
          "Madagascar Charm — فانيليا · فرامبوز",
          "Peruvian Noir — شوكولاتة داكنة ترافل",
          "Ivory Pearl — شوكولاتة بيضاء · مكاديميا",
          "Belgravia Celestial — شوكولاتة بيضاء · فستق · موز",
          "Silken Mist — Dulce de Leche · لوز",
        ],
        heroSub: "ست توقيعات. صُنعت بعناية سماوية.",
        attr1: "بمعايير الشيف",
        attr2: "قوام كامل",
        attr3: "نظام مضخة",
        skuCount: "6 وصفات",
        skuFormat: "زجاجة PET",
        skuUse: "قهوة · كوكتيل · حلويات",
        signatures: {
          overline: "التوقيعات الست",
          title: "ست نكهات. ست لحظات لِتُؤلَّف.",
          deMer: {
            name: "De Mer Whisper",
            flavour: "كراميل مملّح",
            body: "همسة من ملح المحيط فوق كراميل مطبوخ ببطء. يُسكب على Whisky Sour أو Flat White غنيّ.",
          },
          madagascar: {
            name: "Madagascar Charm",
            flavour: "فانيلا · فرمبوز",
            body: "فانيلا بوربون تلتقي بإشراقة التوت. سكب البيت لِـ Spritz و French 75.",
          },
          peruvian: {
            name: "Peruvian Noir",
            flavour: "شوكولاتة داكنة تروفل",
            body: "غنى 70% كاكاو مع عمق التروفل. يُحوّل الموكا إلى لحظة، والفوندان إلى ذكرى.",
          },
          ivory: {
            name: "Ivory Pearl",
            flavour: "شوكولاتة بيضاء · مكاديميا",
            body: "شوكولاتة بيضاء حريرية بدفء المكاديميا المحمّصة. تنساب بأناقة فوق التشيز كيك والجيلاتو.",
          },
          belgravia: {
            name: "Belgravia Celestial",
            flavour: "شوكولاتة بيضاء · فستق · موز",
            body: "أكثر تركيبات البيت مسرحية. فستق وموز فوق شوكولاتة بيضاء كريمية — مُصمَّمة للحلويات الطبقية.",
          },
          silken: {
            name: "Silken Mist",
            flavour: "Dulce de Leche · لوز",
            body: "حليب مُكرمَل بنعومة اللوز المحمّص. توقيعٌ للاتيه والتيراميسو وفترات الظهيرة البطيئة.",
          },
        },
      },
    },
    nav: {
      brands: "الماركات", about: "من نحن", sustainability: "الاستدامة",
      b2b: "أعمال", contact: "تواصل", cta: "كن شريكنا",
      sample: "طلب عينات", distributors: "الموزّعون",
    },
    hero: {
      overline: "منتج تركي لماركات المشروبات والأغذية",
      the: "طعم", tasteOf: "الحياة", living: "الطيّبة", well: ".",
      subtitle: "من تركيا إلى العالم منذ عام 1998 — عائلة من الماركات لمن يهتمّون بما يشربونه ويأكلونه ويشاركونه.",
      exploreBrands: "استكشف ماركاتنا", talkTrade: "تحدث تجارياً",
    },
    about: {
      title: "من نحن",
      body1: "وُلدت من قناعة بسيطة وقوية: أن الطعام والشراب ليسا مجرد منتجات — بل تجارب تربط بين الناس.",
      body2: "منذ البداية كان هدفنا صياغة مجتمع عالمي من الذوق؛ يمزج الجودة والفضول والانفعال في كل لحظة من الحياة اليومية. اليوم تحت مظلة Hupla",
      body3: "تُشكّل عائلة نابضة من الماركات — كل منها يروي قصته الخاصة، وكل منها يستدعي شعوراً مشتركاً بالفرح.",
    },
    brands: {
      title: "أكثر من مجرد بيت ماركات",
      subtitle: "كلّ ماركة من ماركاتنا تعكس إيقاعاً مختلفاً من الحياة",
      portfolio: "المحفظة", of: "من", dragSwipe: "اسحب / مرّر",
      exploreBrand: "استكشف", ourBrands: "ماركاتنا",
      livingCulture: "ثقافة حيّة",
      manifesto1: "كلّ كأس، كلّ رشفة، كلّ نكهة تروي قصة — قصة الأيدي، الحصاد، والبيت.",
      manifesto2: "من إسطنبول إلى الرياض، ومن لاغوس إلى لندن — Hupla هي بهجة العيش الطيّب المشتركة.",
      cities: "من إسطنبول إلى الرياض، ومن لاغوس إلى لندن.",
    },
    sustainability: {
      title: "الاستدامة",
      quote: "بالنسبة لنا، الاستدامة ليست هدفاً — بل أسلوب حياة.",
      body: "كل خطوة في إنتاج Hupla — من مصادر المواد الخام حتى التغليف — تسير وفق التزام مسؤول. سكر أقل، وصفات نباتية، تغليف قابل لإعادة التدوير، وملصقات صادقة — لسنا نضيفها، بل هي أساسنا.",
    },
    group: {
      kicker: "جزء من المجموعة",
      title: "بدعمٍ من هولدينغ استثماري سويسري.",
      body: "Hupla هي شركة إنتاج المشروبات والأغذية ضمن محفظة De Almeda Seligmann Capital AG — مجموعة استثمارية سويسرية يقع مقرها في تسوغ، تدير علاماتها التركية للمشروبات برؤية طويلة الأمد وعابرة للأجيال. عبر الحوكمة السويسرية والحرفة التركية، تواصل استثماراتها ونموّها الطموحين على المستوى العالمي.",
      cta: "dealmedaseligmann.ch",
      pillars: {
        swiss: { title: "حوكمة سويسرية", body: "مسجّل في تسوغ، يلتزم بمعايير الشفافية والإبلاغ من الطراز المؤسسي." },
        long:  { title: "مُشغّل طويل الأمد", body: "رأسمال صبور يفكّر بالأجيال لا الأرباع — هكذا تُبنى علامات المشروبات." },
        global:{ title: "امتداد عالمي", body: "التصنيع متجذّر في تركيا، وطموح التوزيع يمتدّ عبر أوروبا ومنطقة الشرق الأوسط وشمال إفريقيا وما بعدها." },
      },
    },
    b2b: {
      overline: "استفسارات الأعمال",
      titleA: "أوصل Hupla", titleB: "إلى", titleC: "سوقك", titleDot: ".",
      subtitle: "للموزّعين، المستوردين، الحسابات الرئيسية وقطاع الحوريكا — أخبرنا أين أنتم وأيّ الماركات تريدون على رفوفكم. يردّ فريقنا التصديري على الاستفسارات الجادّة خلال يومَي عمل.",
      bullet1: "محفظة ماركات كاملة + حزمة مواصفات",
      bullet2: "حدود دنيا مرنة و مزج الحاويات",
      bullet3: "خيارات ماركة خاصة على خطوط مختارة",
      bullet4: "دعم تسويقي و POS في السوق",
      lblFullName: "الاسم الكامل *", lblCompany: "الشركة *", lblEmail: "البريد المهني *",
      lblPhone: "الهاتف", lblCountry: "البلد / السوق *", lblBrand: "الماركة المهتمّ بها",
      lblInquiryType: "نوع الاستفسار", lblMessage: "أخبرنا عن عملك *",
      phFullName: "أحمد محمد", phCompany: "شركة المشروبات العالمية", phEmail: "ahmed@company.ae",
      phPhone: "+971 50 000 0000", phCountry: "الإمارات العربية المتحدة", phBrandAny: "الكل / أيّ",
      phMessage: "الأحجام المتوقعة، المحفظة الحالية، القنوات المستهدفة…",
      typeDistribution: "توزيع / استيراد", typeHoreca: "حوريكا",
      typePrivate: "ماركة خاصة / تصنيع تعاقدي", typeRetail: "تجزئة", typeOther: "أخرى",
      submit: "إرسال الاستفسار", sending: "جاري الإرسال…",
      privacy: "بإرسالك تقبل أن يتواصل معك Hupla بخصوص استفسارك. نحن لا نشارك بياناتك.",
      successTitle: "تم استلام الاستفسار.",
      successBody: "شكراً لك. سيردّ فريقنا التصديري خلال يومَي عمل.",
      errorFallback: "حدث خطأ. الرجاء المحاولة مرة أخرى.",
      portfolioOverline: "خذها معك",
      portfolioTitle: "محفظة علامات Hupla لعام 2026.",
      portfolioBody: "13 صفحة تحتوي على مواصفات المنتجات، ملاحظات التموضع والصور الرئيسية لكل علامة — Buzzer وMamm وMultimalt وCafeo وAperina وWhite Elephant وDesser.",
      portfolioBullet1: "أحجام العبوات الفعلية والصيغ والحد الأدنى للطلب",
      portfolioBullet2: "التموضع، المستهلك المستهدف وملاءمة القناة",
      portfolioBullet3: "صور منتجات معتمدة، جاهزة للعروض التقديمية",
      portfolioHint: "احصل على ملف PDF جاهز للطباعة ↓",
      portfolioReady: "محفظة علاماتك لعام 2026 جاهزة.",
      portfolioDownload: "تحميل PDF (2.9 ميغابايت)",
    },
    contact: {
      overline: "تواصل", titleA: "قل مرحباً،", titleCity: "إسطنبول", titleB: "تُصغي.",
      subtitle: "مقرّنا في شيشلي بإسطنبول هو قلب Hupla النابض. تواصل معنا للشراكات، الإعلام، الوظائف أو مجرد إلقاء التحية.",
      headquarters: "المقر الرئيسي", office: "المكتب", mobile: "الجوال", email: "البريد",
    },
    footer: {
      overline: "Hupla", titleJoy: "بهجة", titleRest: "الحياة الطيبة.",
      desc: "منتج تركي للمشروبات والأغذية الفاخرة، يصنعها تحت عائلة ماركاته الخاصة لتركيا وأسواق التصدير منذ عام 1998.",
      navigate: "التصفح", ourBrands: "ماركاتنا",
      linkHome: "الرئيسية", linkAbout: "من نحن", linkBrands: "الماركات",
      linkSustainability: "الاستدامة", linkB2B: "استفسار أعمال", linkContact: "تواصل",
      groupCompany: "شركة تابعة للمجموعة",
      groupTagline: "هولدينغ استثماري سويسري يقع مقره في تسوغ — شركتنا الأم على المدى الطويل.",
      headOffice: "المكتب الرئيسي",
      copyright: "جميع الحقوق محفوظة.",
      crafted: "صُنع بعناية في إسطنبول، تركيا.",
    },
    brandPage: {
      backHome: "العودة إلى الماركات", partnerCta: "كن شريكنا",
      whatMakes: "ما يجعلها مميزة", closerLook: "نظرة أقرب على",
      availableIn: "متوفّرة بـ", productLine: "خط المنتج",
      sideBySide: "كل {name} جنباً إلى جنب.",
      skus: "SKU", fromDeck: "من عرض {name}",
      pages: "صفحات", exploreOther: "استكشف ماركات أخرى",
    },
    shows: {
      kicker: "المعارض التجارية 2026",
      title: "قابلونا في المعرض.",
      body: "احجزوا موعدًا مسبقًا لتخصيص جلسة تذوق خاصة مع فريق التصدير لدينا. تسافر معنا مجموعات العينات إلى كل معرض.",
      book: "احجز موعدًا",
      showcasing: "العلامات المعروضة",
    },
    dist: {
      portalOverline: "بوابة الموزّع",
      signInTitle: "تسجيل الدخول.",
      emailPh: "البريد الإلكتروني",
      passwordPh: "كلمة المرور",
      signInBtn: "تسجيل الدخول",
      signingIn: "جارٍ تسجيل الدخول…",
      newDist: "موزّع جديد؟",
      registerLink: "سجّل →",
      useAdminLogin: "الرجاء استخدام دخول المسؤول.",
      loginFailed: "فشل تسجيل الدخول",
      registerTitle: "كن شريكًا لـ Hupla.",
      registerSub: "أخبرنا من أنت وأي منطقة تغطّي — نفتح لك البوابة على الفور.",
      phName: "الاسم الكامل *",
      phCompany: "الشركة *",
      phEmail: "البريد الإلكتروني للعمل *",
      phPassword: "كلمة المرور (8 أحرف على الأقل) *",
      territoryLabel: "المنطقة",
      phArea: "المنطقة / الإقليم *",
      phCity: "المدينة *",
      phCountry: "الدولة *",
      createBtn: "إنشاء الحساب",
      creating: "جارٍ إنشاء الحساب…",
      alreadyRegistered: "مسجّل بالفعل؟",
      signInLink: "تسجيل الدخول →",
      welcomeToast: "مرحبًا بك في Hupla — حساب الموزّع الخاص بك مفعّل.",
      regFailed: "فشل التسجيل",
      welcome: "مرحبًا، {name}.",
      signOut: "تسجيل الخروج",
      yourTerritory: "منطقتك",
      colCompany: "الشركة",
      colArea: "المنطقة",
      colCity: "المدينة",
      colCountry: "الدولة",
      partnerResources: "موارد الشركاء",
      res1Title: "محفظة العلامات 2026",
      res1Body: "الملف التقديمي الكامل بدقة 300 dpi — العلامات السبع بمواصفات المنتجات وأحجام الكراتين.",
      res1Action: "تنزيل PDF",
      res2Title: "طلب عينات فعلية",
      res2Body: "اطلب صناديق العينات إلى مستودعك — نتكفّل بالشحن للموزّعين المعتمدين.",
      res2Action: "طلب عينات",
      res3Title: "قابلونا في المعارض",
      res3Body: "Gulfood · Anuga · SIAL Paris 2026. احجز جلسة تذوق خاصة مع فريق التصدير لدينا.",
      res3Action: "احجز موعدًا",
      helpMail: "بحاجة إلى مساعدة؟ راسلنا على export@hupla.world",
    },
    ageGate: {
      overline: "التحقق من العمر",
      title: "يجب أن يكون عمرك 18 عامًا أو أكثر للدخول.",
      body: "يحتوي هذا القسم على محتوى يتعلق بالمشروبات الكحولية. الرجاء تأكيد بلوغك السنّ القانونية لتناول الكحول في بلدك.",
      yes: "أنا في الـ 18 أو أكبر",
      no: "أنا أقل من 18",
      rejectedBody: "عذرًا — يجب أن يكون عمرك 18 عامًا أو أكثر لمشاهدة هذا المحتوى.",
      goHome: "العودة إلى الرئيسية",
      footer: "الرجاء الشرب بمسؤولية. لا تشارك مع من هم دون السنّ القانونية.",
    },
    we: {
      moreCocktails: {
        overline: "المزيد من البار",
        title: "ست وصفات إضافية مع White Elephant.",
        yuzuSour: {
          pairing: "Yuzu · فودكا",
          name: "Yuzu Sour",
          recipe: "45 مل فودكا · 15 مل ليمون · أضف Yuzu Tonic · رغوة بياض البيض · قشرة يوزو.",
        },
        goldenHighball: {
          pairing: "Yuzu · ويسكي ياباني",
          name: "Golden Highball",
          recipe: "45 مل ويسكي ياباني · مكعب ثلج كبير · أضف Yuzu Tonic · شريحة ليمون.",
        },
        pinkPaloma: {
          pairing: "Barbados · تكيلا بلانكو",
          name: "Pink Paloma",
          recipe: "45 مل تكيلا بلانكو · رشة ملح · أضف Barbados Breeze · قطعة جريب فروت.",
        },
        caribbeanSpritz: {
          pairing: "Barbados · روم مُعتَّق + بروسيكو",
          name: "Caribbean Spritz",
          recipe: "30 مل روم معتَّق · 60 مل بروسيكو · أضف Barbados Breeze · قشرة برتقال.",
        },
        sicilianGT: {
          pairing: "Bitter Lemon · جين متوسطي",
          name: "Sicilian G&T",
          recipe: "45 مل جين متوسطي · غصن إكليل الجبل · أضف Bitter Lemon · حلقة ليمون.",
        },
        vodkaBitter: {
          pairing: "Bitter Lemon · فودكا",
          name: "Cucumber Bitter",
          recipe: "45 مل فودكا · 3 شرائح خيار · أضف Bitter Lemon · غصن نعناع.",
        },
      },
    },
    sample: {
      kicker: "طلب عينات",
      title: "جرّبها قبل الإدراج.",
      sub: "أخبرنا بعنوان الشحن والعلامات التي تودّ إدراجها — نتكفّل بالنقل للحسابات الجادّة.",
      phName: "الاسم الكامل *",
      phCompany: "الشركة *",
      phEmail: "البريد الإلكتروني للعمل *",
      phPhone: "الهاتف",
      phCountry: "الدولة / السوق *",
      phAddress: "عنوان الشحن *",
      brandsLabel: "العلامات المطلوبة *",
      phNotes: "ملاحظات (اختياري)",
      submit: "اطلب عينات",
      sending: "جارٍ الإرسال…",
      thanks: "العينات في الطريق.",
      thanksBody: "سيؤكد فريق التصدير عنوان الشحن خلال يومَي عمل ثم يرسل العينات مباشرةً بعد ذلك.",
      close: "إغلاق",
      errNoBrand: "الرجاء اختيار علامة واحدة على الأقل",
      errServer: "حدث خطأ ما. الرجاء المحاولة مرة أخرى.",
      success: "تم استلام طلب العينات — سنتواصل معك.",
    },
  },
};

// Resolve a dot-key path within the current lang, falling back to English
export function resolve(lang, key) {
  const parts = key.split(".");
  const walk = (obj) => parts.reduce((o, p) => (o && o[p] != null ? o[p] : undefined), obj);
  const v = walk(T[lang]);
  return v != null ? v : walk(T.en) ?? key;
}

export default T;
